import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          welcome: "Welcome! Choose your language:",
          level: "What is your English level?",
          purpose: "Why are you learning English?",
          videos: "Here are some videos for you:",
          register: "Sign up to continue",
          options: {
            beginner: "I don't know anything yet",
            elementary: "Beginner",
            intermediate: "Intermediate",
            advanced: "Advanced",
            travel: "Preparation for travel",
            job: "For job interviews",
            education: "Educational purposes",
            communication: "To communicate with people",
            fun: "For fun",
          },
          welcome: "Welcome to our website",
          aboutUs: "About Us",
          contact: "Contact",
          services: "Services",
          blog: "Blog",
          catalog: "Catalog",
          buyNow: "Buy Now",
          addToCart: "Add to Cart",
          checkout: "Checkout",
          totalPrice: "Total Price",
          search: "Search",
          enterYourEmail: "Enter your email",
          subscribe: "Subscribe",
          latestNews: "Latest News",
          readMore: "Read More",
          sendMessage: "Send Message",
          name: "Name",
          email: "Email",
          message: "Message",
          submit: "Submit",
          loading: "Loading...",
          "Loading...": "Loading...",
          success: "Success!",
          error: "An error occurred. Please try again.",
          signin: "Sign in",
          password: "Password",
          forgotpassword: "Forgot Password",
          oro: "or",
          account: "Don't have an account?",
          register: "Register",
          login: "Log In",
          loading: "Loading",
          signup: "Sign Up",
          "Sign Up": "Sign Up",
          username: "Username",
          confirmpassword: "Confirm Password",
          haveac: "Already have an account?",
          logout: "Logout",
          registerforfree: "Register for free",
          "Start speaking with confidence from day one": "Start speaking with confidence from day one",
          "Start Learning Free": "Start Learning Free",
          "Choose your English level and topics that interest you": "Choose your English level and topics that interest you",
          "All Categories": "All Categories",
          "All Levels": "All Levels",
          "Search videos by title": "Search videos by title",
          watch: "Learn New Words",
          watchbig:
            "Build your personal vocabulary or let AI select the most useful words for you.",
          learn: "Watch Videos",
          learnBig:
            "Dive into real-life conversations tailored to your level and goals.",
          speak: "Discuss",
          speakBig:
            "Chat with AI – by text or voice – just like in real conversations.",
          discuss: "Get Feedback on Your Answers",
          discussBig:
            "AI checks your answers, explains mistakes, and helps you improve.",
          popularVideo: "Popular Video",
          allLevels: "Language Level",
          showAll: "Show all",
          filter: "Filter",
          chooseLanguage:
            "In which language would you like to view the website?",
          popupTitle: "Would you like to start learning?",
          startLearning: "Start",
          startyFirstTitle: "Speak the world",
          levelonea: "Beginner",
          leveltwoa: "Elementary",
          levevoneb: "Intermediate",
          lebeltwob: "Upper-Intermediate",
          levelonec: "Advanced",
          leveltwoc: "Proficient",
          levelBeginnerGroup: "Beginner",
          levelIntermediateGroup: "Intermediate",
          levelAdvancedGroup: "Advanced",
          allLevelsOption: "All Levels",
          contButton: "Continue",
          pojasn: "Explanation",
          pruklad: "Example of use",
          showMore: "Show More",
          showLess: "Show Less",
          searchPlaceholder: "Enter video title",
          videoNotFound: 'Video with the title "" not found',
          noVideosForFilters: "No videos found for selected filters",
          allVideos: "All Videos",
          grammar: {
            verb: "Verb",
            infinitive: "Infinitive",
            thirdPersonSingular: "Third person singular",
            pastTense: "Past tense",
            pastParticiple: "Past participle",

            adjective: "Adjective",
            adverb: "Adverb",
            comparative: "Comparative",
            superlative: "Superlative",

            pronoun: "Pronoun",
            reflexiveForm: "Reflexive form",
            objectForm: "Object form",
            possessiveForm: "Possessive form",

            determiner: "Determiner",
            singular: "Singular",
            plural: "Plural",

            number: "Number",

            abbreviation: "Abbreviation",
            fullForm: "Full form",
            yes: "yes",
            no: "no",
          },
          "English": "English",
          "Polski": "Polski",
          "Українська": "Ukrainian",
          "Polish": "Polish",
          "Ukrainian": "Ukrainian",
          "My learning": "My learning",
          "All Videos": "All Videos",
          "Words learned": "Words learned",
          "Videos completed": "Videos completed",
          "Questions answered correctly": "Questions answered correctly",
          "Dialogues role played successfully": "Dialogues role played successfully",
          "All My Videos": "All My Videos",
          "In Progress": "In Progress",
          "Completed": "Completed",
          "❤️ Favorites": "❤️ Favorites",
          "words": "words",
          "word": "word",
          "Total Words": "Total Words",
          "Words in Dictionary": "Words in Dictionary",
          "Watch Video": "Watch Video",
          "Watch the full lesson video": "Watch the full lesson video",
          "Study Words": "Study Words",
          "Learn vocabulary in context": "Learn vocabulary in context",
          "Check Understanding": "Check Understanding",
          "Test your comprehension": "Test your comprehension",
          "Practice Dialogues": "Practice Dialogues",
          "Real-life conversations": "Real-life conversations",
          "Common Mistakes": "Common Mistakes",
          "Example": "Example",
          "Log Out": "Log Out",
          "Log In": "Log In",
          "days remaining": "days remaining",
          "Welcome back": "Welcome back",
          "Language level": "Language level",
          "Travel": "Travel",
          "Education": "Education",
          "Work": "Work",
          "Health": "Health",
          "News & Technology": "News & Technology",
          "Leisure": "Leisure",
          "Daily Life": "Daily Life",
          "Beginner": "Beginner",
          "Elementary": "Elementary",
          "Intermediate": "Intermediate",
          "Upper-Intermediate": "Upper-Intermediate",
          "Advanced": "Advanced",
          "Proficiency": "Proficiency",
          "INF": "INF",
          "V2": "V2",
          "V3": "V3",
          "3 SG": "3 SG",
          "SG": "SG",
          "PL": "PL",
          "BASE": "BASE",
          "COMP": "COMP",
          "SUP": "SUP",
          "REFL": "REFL",
          "OBJ": "OBJ",
          "POSS": "POSS",
          "FULL": "FULL",
          "Master Your English!": "Master Your English!",
          "Start Testing": "Start Testing",
          "Choose your challenge:": "Choose your challenge:",
          "Yes/No Questions": "Yes/No Questions",
          "Watch Video": "Watch Video",
          "Learn Words": "Learn Words",
          "understanding2": 'Check Understanding',
          "practiceDialogues2": "Practice Dialogues",
          "Immerse yourself in authentic content featuring real-life videos with practical, everyday vocabulary you'll actually use.": "Immerse yourself in authentic content featuring real-life videos with practical, everyday vocabulary you'll actually use.",
          "Focus your energy efficiently by studying only the words from videos that are new to you, maximizing your learning time.": "Focus your energy efficiently by studying only the words from videos that are new to you, maximizing your learning time.",
          "Assess your comprehension through interactive questions, voice-based answers, and targeted review of new vocabulary.": "Assess your comprehension through interactive questions, voice-based answers, and targeted review of new vocabulary.",
          "Apply your knowledge in realistic conversations based on the videos you've watched, building confidence for real-world interactions.": "Apply your knowledge in realistic conversations based on the videos you've watched, building confidence for real-world interactions.",
          "Text/Voice Response": "Text/Voice Response",
          "Drag & Drop": "Drag & Drop",
          "Attempts": "Attempts",
          "attempts": "attempts",
          "Click any question to jump directly to it!": "Click any question to jump directly to it!",
          "View Results": "View Results",
          "Question": "Question",
          "Hint": "Hint",
          "Next Question": "Next Question",
          "Finish Test": "Finish Test",
          "Please select at least one test type!": "Please select at least one test type!",
          "No questions available!": "No questions available!",
          "Loading questions...": "Loading questions...",
          "This may take 5-10 seconds for new content": "This may take 5-10 seconds for new content",
          "of": "of",
          "of": "of",
          "Select your answer – it will be checked automatically": "Select your answer – it will be checked automatically",
          "YES": "YES",
          "NO": "NO",
          "Correct": "Correct",
          "Partial": "Partial",
          "Partially Correct": "Partially Correct",
          "Incorrect": "Incorrect",
          "Next Question": "Next Question",
          "Answer by Text or Voice": "Answer by Text or Voice",
          "Type your answer below or click the microphone to record your voice": "Type your answer below or click the microphone to record your voice",
          "Type your answer here…": "Type your answer here…",
          "Ready": "Ready",
          "Answered": "Answered",
          "Check Answer": "Check Answer",
          "Recording...": "Recording...",
          "Your answer:": "Your answer:",
          "Drag the words to complete the sentence:": "Drag the words to complete the sentence:",
          "Your answer will be checked automatically when all gaps are filled": "Your answer will be checked automatically when all gaps are filled",
          "Try Again": "Try Again",
          "Scroll down to see your detailed error analysis": "Scroll down to see your detailed error analysis",
          "Outstanding!": "Outstanding!",
          "Keep Growing!": "Keep Growing!",
          "Great Job!": "Great Job!",
          "Good Effort!": "Good Effort!",
          "Error Analysis": "Error Analysis",
          "Understanding your mistakes helps you learn better": "Understanding your mistakes helps you learn better",
          "Key Areas for Improvement": "Key Areas for Improvement",
          "Incorrect Answers": "Incorrect Answers",
          "Partially Correct Answers": "Partially Correct Answers",
          "Correct answer:": "Correct answer:",
          "You've mastered this material! Your understanding is exceptional.": "You've mastered this material! Your understanding is exceptional.",
          "Every expert was once a beginner. Keep practicing and you'll get there!": "Every expert was once a beginner. Keep practicing and you'll get there!",
          "You've completed your": "You've completed your",
          "You're doing really well! Keep up the excellent work.": "You're doing really well! Keep up the excellent work.",
          "You're making progress! A little more practice will help you improve.": "You're making progress! A little more practice will help you improve.",
          "Focus on careful reading - multiple Yes/No questions were missed. Pay attention to keywords like 'not', 'only', or 'all'.": "Focus on careful reading - multiple Yes/No questions were missed. Pay attention to keywords like 'not', 'only', or 'all'.",
          "Practice word order and grammar structures - drag & drop questions show gaps in understanding sentence construction.": "Practice word order and grammar structures - drag & drop questions show gaps in understanding sentence construction.",
          "Work on expressing complete thoughts - text/voice answers need more detail and accuracy.": "Work on expressing complete thoughts - text/voice answers need more detail and accuracy.",
          "Consider reviewing the material more thoroughly before attempting again. Take notes on key concepts.": "Consider reviewing the material more thoroughly before attempting again. Take notes on key concepts.",
          "You're showing good understanding but need to refine some details. Focus on the specific areas mentioned above.": "You're showing good understanding but need to refine some details. Focus on the specific areas mentioned above.",
          "No answer": "No answer",
          "No answer provided": "No answer provided",
          "N/A": "N/A",
          "See explanation": "See explanation",
          "Review Your Answer": "Review Your Answer",
          "See your answer and the explanation for this question": "See your answer and the explanation for this question",
          "← Back to Results": "← Back to Results",
          "Review Mode": "Review Mode",
          "Review all your answers and explanations": "Review all your answers and explanations",
          "Previous": "Previous",
          "Next": "Next",
          "Please provide an answer!": "Please provide an answer!",
          "Microphone access denied. Please type your answer.": "Microphone access denied. Please type your answer.",
          "Mic denied": "Mic denied",
          "Voice recording saved": "Voice recording saved",
          "Failed to submit your recording. Please try again.": "Failed to submit your recording. Please try again.",
          "Failed to play recording": "Failed to play recording",
          "Voice recording transcribed": "Voice recording transcribed",
          "Voice recording submitted": "Voice recording submitted",
          "Processing...": "Processing...",
          "Stopping in": "Stopping in",
          "Welcome to Dialogue Studio!": "Welcome to Dialogue Studio!",
          "firstPopDes": "Let's practice your English speaking skills. You'll need to use 5 target vocabulary words in our conversation.",
          "Yes, I'm Ready!": "Yes, I'm Ready!",
          "FINISH SESSION": "FINISH SESSION",
          "Word Treasury": "Word Treasury",
          "YOUR PROGRESS": "YOUR PROGRESS",
          "Words Used": "Words Used",
          "PRESS TO SPEAK": "PRESS TO SPEAK",
          "Listening to you...": "Listening to you...",
          "I don't understand the question": "I don't understand the question",
          "I can't answer": "I can't answer",
          "Time Invested": "Time Invested",
          "Time Spent": "Time Spent",
          "Welcome to your": "Welcome to your",
          "restFirstMessageT": "dialogue practice! I'm excited to explore this topic with you. Try using the 5 vocabulary words shown on the right.",
          "Exchanges": "Exchanges",
          "Words Mastered": "Words Mastered",
          "Brilliant Session!": "Brilliant Session!",
          "You've created something beautiful with words today": "You've created something beautiful with words today",
          "Your Achievements": "Your Achievements",
          "Perfect! You used all 5 vocabulary words brilliantly!": "Perfect! You used all 5 vocabulary words brilliantly!",
          "New Adventure": "New Adventure",
          "Exit": "Exit",
          "Welcome Back!": "Welcome Back!",
          "You have an unfinished dialogue session for": "You have an unfinished dialogue session for",
          "You've used": "You've used",
          "out of 5 vocabulary words.": "out of 5 vocabulary words.",
          "Continue Session": "Continue Session",
          "Start Over": "Start Over",
          "In which language would you like to view the website?": "In which language would you like to view the website?",
          "Take the test — get a program personalized to your goal and level": "Take the test — get a program personalized to your goal and level",
          "It will take less than 1 minute": "It will take less than 1 minute",
          "Quick & Easy": "Quick & Easy",
          "Step 1 of 2": "Step 1 of 2",
          "Step 2 of 2": "Step 2 of 2",
          "What is your current English level?": "What is your current English level?",
          "What's your main goal with English?": "What's your main goal with English?",
          "Great! We've prepared your personalized learning path": "Great! We've prepared your personalized learning path",
          "Finish test": "Finish test",
          "English Learning Journey": "English Learning Journey",
          "Lower Level": "Lower Level",
          "Add Plan": "Add Plan",
          "Raise Level": "Raise Level",
          "Learning Progress": "Learning Progress",
          "Current Level": "Current Level",
          "Basics": "Basics",
          "Conversations": "Conversations",
          "Introduction": "Introduction",
          "Greetings": "Greetings",
          "Practice": "Practice",
          "Daily Talk": "Daily Talk",
          "Questions": "Questions",
          "Social": "Social",
          "Business": "Business",
          "Emails": "Emails",
          "Meetings": "Meetings",
          "Airport": "Airport",
          "Hotels": "Hotels",
          "Dining": "Dining",
          "Grammar": "Grammar",
          "Idioms": "Idioms",
          "Fluency": "Fluency",
          "I want to choose the video myself": "I want to choose the video myself",
          "Continue Learning": "Continue Learning",
          "TRY 2-MIN DEMO": "TRY 2-MIN DEMO",
          "WHY CHOOSE AI LINGUA?": "WHY CHOOSE AI LINGUA?",
          "REAL-LIFE VIDEOS": "REAL-LIFE VIDEOS",
          "AI-POWERED PRACTICE": "AI-POWERED PRACTICE",
          "ALL LEVELS WELCOME": "ALL LEVELS WELCOME",
          // Level descriptions
          "Preparatory course. Ideal for beginners": "Preparatory course. Ideal for beginners",
          "I am starting to learn English.": "I am starting to learn English.",
          "I already know some words": "I already know some words",
          "I can already speak a little": "I can already speak a little",
          "I confidently speak on various topics": "I confidently speak on various topics",
          "I can discuss various topics in detail": "I can discuss various topics in detail",
          "Enter your credentials to access your account": "Enter your credentials to access your account",
          "coming soon": "coming soon",
          "Login successful": "Login successful",
          "Login failed": "Login failed",
          "Create your account to get started": "Create your account to get started",
          "Plans that fit your needs": "Plans that fit your needs",
          "Simple, scalable pricing that grows with you.": "Simple, scalable pricing that grows with you.",
          "Free": "Free",
          "Get Started": "Get Started",
          "Free for everyone": "Free for everyone",
          "Watch learning videos": "Watch learning videos",
          "Add words to personal vocabulary": "Add words to personal vocabulary",
          "Study & review words": "Study & review words",
          "Video comprehension checks": "Video comprehension checks",
          "AI voice dialogues": "AI voice dialogues",
          "Certificate upon completion": "Certificate upon completion",
          "Priority support": "Priority support",
          "Cancel & Refund Policy": "Cancel & Refund Policy",
          "Pro": "Pro",
          "Popular": "Popular",
          "Pricing": "Pricing",
          "AI voice dialogues — 10 per day": "AI voice dialogues — 10 per day",
          "Unlimited AI voice dialogues": "Unlimited AI voice dialogues",
          "All Pro features included": "All Pro features included",
          "Per-user progress reports": "Per-user progress reports",
          "Training reminders for learners": "Training reminders for learners",
          "Custom branding options": "Custom branding options",
          "Dedicated account manager": "Dedicated account manager",
          "Volume discounts available": "Volume discounts available",
          "API access & integrations": "API access & integrations",
          "All rights reserved": "All rights reserved",
          "Terms of Use": "Terms of Use",
          "Privacy Policy": "Privacy Policy",
          "Cookie Settings": "Cookie Settings",
          "Terms of Use2": "Terms of Use",
          "Last updated": "Last updated",
          "temrs1Text": "AI Lingua is an online platform for learning English (video lessons, dictionary, comprehension tests, and AI-powered dialogue practice). Access is provided in digital form only; no physical goods are supplied.",
          "terms2": "Payments are processed by Paddle.com; invoices/receipts and applicable taxes are administered by Paddle.",
          "terms3": "Service owner: Sole Proprietor Alona Oleksandrivna Korchynska (FOP Korchynska Alona Oleksandrivna)",
          "terms4": "| Jurisdiction: Ukraine",
          "terms5": "Postal address: Starokostiantyniv, Khmelnytskyi Oblast, 31100, Ukraine",
          "terms6": "The minimum user age is 13; individuals under 13 may not use the Service. If you reside in an EU/EEA country or the United Kingdom and you are under 16, verified parental/guardian consent is required (if the law of your country allows a lower age of consent, we will honor that). You are responsible for keeping your login credentials confidential and not sharing access with third parties.",
          "terms7": "Paddle.com Acting as Merchant of Record.",
          "terms8": "Payments are accepted and invoices/receipts are issued by Paddle.com as the seller/merchant of record, including the calculation and collection of applicable taxes/VAT. Plans and prices are published on the pricing page and may change with prior notice where they affect future billing periods. Subscriptions renew automatically unless cancelled in your account dashboard (auto‑renewal is disabled upon cancellation; access continues until the end of the already‑paid period).",
          "terms9": "The trial period is 7 days. If you purchase a subscription during the trial, paid access begins immediately while the trial continues until the end of the 7 days (overall access is not doubled). A free version with limited functionality is available.",
          "terms10": "Refunds after subscription payment are not provided, including partial/prorated amounts, except where required by mandatory applicable law or under our exceptions policy.",
          "terms11": "Prohibited: violations of law; aggressive, discriminatory, or harmful content; attempts at unauthorized access, interference with the Service, or reverse engineering; automated mass data collection; payment fraud; account sharing by multiple individuals; uploading or inputting materials that infringe third‑party IP rights. Accounts that violate these Terms may be restricted or closed after notice where reasonably possible.",
          "terms12": "Service materials (including videos, tests, software code, design, texts) are protected by intellectual property rights. We grant you a limited, non‑exclusive, non‑transferable license to use the Service for personal, non‑commercial purposes. Content uploaded by users remains their property; users grant the Service a limited license to use such content for the purposes of providing and improving the Service.",
          "terms13": "We engage third‑party providers (hosting, analytics, and LLM models for AI dialogues). Data is processed solely to provide, support, and improve the Service. We do not use your content to train providers' general models unless we explicitly state otherwise and obtain your consent. The list of key providers and server locations is set out in the Privacy Policy.",
          "terms14": "We may update features, prices, and terms. We provide at least 7 days' notice (email/in‑account banner) of material changes that affect payment or access. Continued use after the effective date constitutes acceptance of the updated terms.",
          "terms15": "We may suspend or terminate a user's access in case of a breach of these Terms or for security/legal reasons, with reasonable notice where possible. Upon termination, you may export your data within 30 days (except where legal restrictions apply).",
          "terms16": "The Service is provided \"as is\" and \"as available.\" To the extent permitted by law, no implied warranties of fitness or suitability for a particular purpose are provided. The Service owner's aggregate liability to a user is limited to the amounts paid by that user in the last 12 months.",
          "terms17": "These Terms are governed by the laws of Ukraine; disputes are subject to the competent courts of Ukraine unless mandatory norms provide otherwise.",
          "terms18": "Questions regarding the Service and billing (including subscription cancellation):",
          "About Us": "About Us",
          "Accounts and Age": "Accounts and Age",
          "Subscriptions, Pricing, and Billing": "Subscriptions, Pricing, and Billing",
          "Trial Period and Free Version": "Trial Period and Free Version",
          "Refunds": "Refunds",
          "Acceptable Use": "Acceptable Use",
          "Intellectual Property Rights": "Intellectual Property Rights",
          "Third-Party Technologies and AI": "Third-Party Technologies and AI",
          "Service Availability and Changes": "Service Availability and Changes to the Service and Prices",
          "Termination of Access": "Termination of Access",
          "Warranty Disclaimer": "Warranty Disclaimer and Limitation of Liability",
          "Governing Law and Contact": "Governing Law, Jurisdiction, and Contact",
          "October": "October",
          "Who We Are": "Who We Are",
          "privacy1": "Sole Proprietor Alona Oleksandrivna Korchynska is the data controller for AI Lingua. Contacts:",
          "Data We Process": "Data We Process",
          "privacy2": "email, password (hashed), name/pseudonym.",
          "privacy3": "progress, test results, settings, activity logs.",
          "privacy4": "processed by Paddle.com (we receive transaction/subscription status and Order ID; we do not store full card details).",
          "privacy5": "cookies/telemetry for site operation, security, and analytics.",
          "Purposes": "Purposes",
          "privacy6": "Providing the Service, billing, support, security, analytics/improvements, compliance with legal obligations.",
          "Legal Bases": "Legal Bases",
          "privacy7": "Performance of a contract; legitimate interests; consent (where required); legal obligation.",
          "Data Sharing": "Data Sharing",
          "privacy8": "With infrastructure/analytics providers and Paddle.com — subject to appropriate safeguards.",
          "privacy8.1": "With infrastructure/analytics providers and",
          "privacy8.2": "— subject to appropriate safeguards.",
          "Retention": "Retention",
          "privacy9": "For as long as the account is active; specific records may be retained longer where required by law (e.g., financial reporting).",
          "Data Subject Rights": "Data Subject Rights",
          "privacy10": "Send requests for access/erasure/portability/objection to ailinguaservice@gmail.com. We respond within 30 days. You also have the right to lodge a complaint with the Ukrainian Parliament Commissioner for Human Rights (Ombudsman) or the supervisory authority in your country of residence.",
          "International Transfers": "International Transfers",
          "privacy11": "When we transfer data outside Ukraine/the EU, we use Standard Contractual Clauses (SCCs) or other appropriate safeguards. The list of main providers and processing countries is provided in the relevant section/appendix.",
          "Cookies": "Cookies",
          "privacy12": "We use necessary cookies for site operation and analytics/marketing cookies only with your consent. You can change your choice at any time in the consent banner.",
          "Account": "Account",
          "Learning": "Learning",
          "Payments": "Payments",
          "Technical": "Technical",
          "Cancellation and Refund Policy": "Cancellation and Refund Policy",
          "refund1": "7 days. If a subscription is purchased during the trial, trial access continues until the end of the 7 days.",
          "refund2": "charged via Paddle; the subscription auto‑renews until cancelled.",
          "refund3": "at any time in your dashboard/through Paddle; after cancellation, access remains until the end of the already‑paid period.",
          "refund4": "not provided after subscription payment (including partial/prorated amounts), except where required by applicable law.",
          "refund5": "Billing/cancellation contact:",
          "Trial period:": "Trial period:",
          "Payment and auto-renewal:": "Payment and auto‑renewal:",
          "CNCL": "Cancellation:",
          "RFND": "Refunds:",
          "app-header-text": "Now we’ll practice the dialogue from the video. We’ll speak just like in the clip: the same words and the same topic. Let’s begin.",
          "Try saying it like this:": "Try saying it like this:",
          "Keep practicing!": "Keep practicing!",
          "Not bad!": "Not bad!",
          "Good job!": "Good job!",
          "Excellent result!": "Excellent result!",
          "Skip": "Skip",
          "Take a break and review!": "Take a break and review!",
          "You\'ve tried five times already - that\'s great persistence! But it seems like it would be worth refreshing the material so the dialogue goes easier.": "You\'ve tried five times already - that\'s great persistence! But it seems like it would be worth refreshing the material so the dialogue goes easier.",
          "Mistakes are part of learning": "Mistakes are part of learning",
          "Nothing scary, it happens!": "Nothing scary, it happens!",
          "It seems difficult to answer by voice for now. Let\'s first review the material again - after that it will be much easier!": "It seems difficult to answer by voice for now. Let\'s first review the material again - after that it will be much easier!",
          "One step back is two steps forward": "One step back is two steps forward",
          "We recommend returning to:": "We recommend returning to:",
          "Learn Words2": "Learn Words",
          "Review key words and phrases from the lesson": "Review key words and phrases from the lesson",
          "Watch Video2": "Watch Video",
          "Watch the dialogue again with subtitles": "Watch the dialogue again with subtitles",
          "I want to continue the dialogue": "I want to continue the dialogue",
          "Lesson completed": "Lesson completed",
          "Great! Lesson": "Great! Lesson",
          "completed!": "completed!",
          "You\'ve completed the dialogue practice for this video. You can now move on to the next lesson or review this one again.": "You\'ve completed the dialogue practice for this video. You can now move on to the next lesson or review this one again.",
          "Repeat Lesson": "Repeat Lesson",
          "Next Lesson": "Next Lesson",
          "Almost there!": "Almost there!",
          "Don't be sad": "Don't be sad",
          "Every attempt": "Every attempt",
          "is a step forward": "is a step forward",
          "This time the lesson": "This time the lesson",
          "was not completed — but that's okay. Mistakes are part of learning. Repeat the lesson or move on: your choice!": "This time the lesson was not completed — but that's okay. Mistakes are part of learning. Repeat the lesson or move on: your choice!",
          "Awesome plan for you": "Awesome plan for you",
          "Access to 30 video pack": "Access to 30 video pack",
          "Subscriptions": "Subscriptions",
          "Sign in to manage your subscription": "Sign in to manage your subscription",
          "Please log in to view and manage your subscription details, billing information, and account settings.": " Please log in to view and manage your subscription details, billing information, and account settings.",
          "You can manage your billing information and subscription here": "You can manage your billing information and subscription here",
          "You're on the": "You're on the",
          "plan": "plan",
          "Next renewal:": "Next renewal:",
          "Plan cost": "Plan cost:",
          "Status": "Status",
          "Auto-renewal": "Auto-renewal",
          "Cancel Subscription": "Cancel Subscription",
          "Upgrade your plan": "Upgrade your plan",
          "Processing payment": "Processing payment",
          "We are waiting for confirmation from the payment provider...": "We are waiting for confirmation from the payment provider...",
          "Your subscription plan": "Your subscription plan",
          "Activation progress": "Activation progress",
          "Do not close this page - we will notify you immediately": "Do not close this page - we will notify you immediately",
          "Successfully activated!": "Successfully activated!",
          "Your subscription plan": "Your subscription plan",
          "Do not waste time - let's learn together! All features of the plan": "Do not waste time - let's learn together! All features of the plan",
          "are already available in your account.": "are already available in your account.",
          "Thank you for trusting AI Lingua!": "Thank you for trusting AI Lingua!",
          "Subscription": "Subscription",
          "Tel": "Tel",
          "Custom Pricing": "Custom Pricing",
          "Стандарт": "Standard",
          "Преміум": "Premium",
          "Contact Us": "Contact Us",
          "After registration, you'll get your personalized course and be able to track your progress.": "After registration, you'll get your personalized course and be able to track your progress.",
          "Start your language learning journey with AI-powered lessons tailored just for you!": "Start your language learning journey with AI-powered lessons tailored just for you!",
          "Welcome Back, aliona!": "Welcome Back, aliona!",
          "Let's continue studying together": "Let's continue studying together",
          "Learned Words": "Learned Words",
          "Completed Videos": "Completed Videos",
          "Correct Answers": "Correct Answers",
          "Successful Dialogues": "Successful Dialogues",
          "My Courses": "My Courses",
          "View all courses": "View all courses",
          "Business English": "Business English",
          "Intermediate": "Intermediate",
          "24 lessons": "24 lessons",
          "Progress": "Progress",
          "lessons done": "lessons done",
          "lessons left": "lessons left",
          "Conversational English": "Conversational English",
          "30 lessons": "30 lessons",
          "Travel English": "Travel English",
          "15 lessons": "15 lessons",
          "My Videos": "My Videos",
          "View all": "View all",
          "Name": "Name",
          "Email": "Email",
          "Phone": "Phone",
          "Message": "Message",
          "Submit": "Submit",
          "Please fill in all the fields!": "Please fill in all the fields!",
          "Completed Dialogs": "Completed Dialogs",
          "Введіть коректну адресу електронної пошти.": "Please enter a valid email address.",
          "The email address and/or password you specified are not correct.": "The email address and/or password you specified are not correct.",
          "Choose a username": "Choose a username",
          "Це поле обов'язкове.": "This field is required.",
          "A user is already registered with this email address.": "A user is already registered with this email address.",
          "Register to save your progress": "Register to save your progress",
          "Register": "Register",
          "Previous Lesson": "Previous Lesson",
          "Lesson Completed": "Lesson Completed",
          "Lesson Not Completed": "Lesson Not Completed",
          "Email must contain @": "Email must contain @",
          "Email must contain . (dot)": "Email must contain . (dot)",
          "Invalid email format (example@domain.com)": "Invalid email format (example@domain.com)",
          "At least 8 characters": "At least 8 characters",
          "Must contain letters": "Must contain letters",
          "Must contain numbers": "Must contain numbers",
        },
      },
      uk: {
        translation: {
          welcome: "Ласкаво просимо! Виберіть вашу мову:",
          level: "Який у вас рівень англійської?",
          purpose: "Для чого ви вивчаєте англійську мову?",
          videos: "Ось деякі відео для вас:",
          register: "Зареєструйтесь, щоб продовжити",
          options: {
            beginner: "Новачок",
            elementary: "Початковий",
            intermediate: "Середній",
            advanced: "Просунутий",
            travel: "Подорожі",
            job: "Робота",
            education: "Освітна",
            communication: "Комунікації",
            fun: "Задля розваги",
          },
          aboutUs: "Про нас",
          contact: "Контакти",
          services: "Послуги",
          blog: "Блог",
          catalog: "Каталог",
          buyNow: "Купити зараз",
          addToCart: "Додати в кошик",
          checkout: "Оформити замовлення",
          totalPrice: "Загальна вартість",
          search: "Пошук",
          enterYourEmail: "Введіть ваш email",
          subscribe: "Підписатися",
          latestNews: "Останні новини",
          readMore: "Читати більше",
          sendMessage: "Надіслати повідомлення",
          name: "Ім'я",
          email: "Email",
          message: "Повідомлення",
          submit: "Надіслати",
          loading: "Завантаження...",
          "Loading...": "Завантаження...",
          success: "Успішно!",
          error: "Сталася помилка. Будь ласка, спробуйте ще раз.",
          signin: "Увійти",
          password: "Пароль",
          forgotpassword: "Забули пароль",
          oro: "або",
          account: "Немає акаунту?",
          register: "Реєстрація",
          login: "Увійти",
          loading: "Завантаження",
          signup: "Зареєструватися",
          username: "Ім'я користувача",
          confirmpassword: "Підтвердити пароль",
          haveac: "Вже маєте акаунт?",
          logout: "Вийти",
          registerforfree: "Зареєструватися безкоштовно",
          "Start speaking with confidence from day one": "Почніть говорити впевнено з першого дня",
          "Start Learning Free": "ПОЧНИ ВЧИТИСЯ БЕЗКОШТОВНО",
          "Choose your English level and topics that interest you": "Обери свій рівень англійської та теми, що тебе цікавлять",
          "All Categories": "Усі категорії",
          "All Levels": "Усі рівні",
          "Search videos by title": "Шукай відео за назвою",
          "Immerse yourself in authentic content featuring real-life videos with practical, everyday vocabulary you'll actually use.": "Поринь у справжній контент з реальними відео та практичною повсякденною лексикою, яку ти справді будеш використовувати.",
          "Learn Words": "Вивчай слова",
          "Focus your energy efficiently by studying only the words from videos that are new to you, maximizing your learning time.": "Використовуй свою енергію ефективно, вивчаючи лише ті слова з відео, які є новими для тебе, і таким чином максимально використовуючи час навчання.",
          "understanding2": "Перевір розуміння",
          "Assess your comprehension through interactive questions, voice-based answers, and targeted review of new vocabulary.": "Перевіряй розуміння за допомогою інтерактивних запитань, голосових відповідей і цільового повторення нової лексики.",
          "practiceDialogues2": "Практикуй діалоги",
          "Apply your knowledge in realistic conversations based on the videos you've watched, building confidence for real-world interactions.": "Застосовуй знання у реальних розмовах на основі переглянутих відео, набуваючи впевненості для справжніх ситуацій.",
          watch: "Вивчай нові слова",
          watchbig:
            "Складай персональний словник або вивчай слова, які підібрав AI – тільки найнеобхідніше для тебе.",
          learn: "Дивись відео",
          learnBig:
            "Занурюйся у живі діалоги, що відповідають твоєму рівню та цілям.",
          speak: "Обговорюй",
          speakBig:
            "Практикуй розмову з AI – текстом або голосом, як у справжньому спілкуванні.",
          discuss: "Отримай зворотний зв'язок на свої відповіді",
          discussBig:
            "AI перевіряє твої відповіді, пояснює помилки та допомагає їх виправити.",
          popularVideo: "Популярні відео",
          allLevels: "Рівень мови",
          showAll: "Показати всі",
          filter: "Фільтр",
          chooseLanguage: "На якій мові вам зручно бачити сайт?",
          popupTitle: "Бажаєте розпочати навчання?",
          startLearning: "Розпочати",
          startyFirstTitle: "Говори мовами світу",
          levelonea: "Початковий",
          leveltwoa: "Елементарний",
          levevoneb: "Середній",
          lebeltwob: "Вище середнього",
          levelonec: "Високий",
          leveltwoc: "Професійний",
          levelBeginnerGroup: "Початковий",
          levelIntermediateGroup: "Середній",
          levelAdvancedGroup: "Високий",
          allLevelsOption: "Усі рівні",
          contButton: "Продовжити",
          pojasn: "Пояснення",
          pruklad: "Приклад застосування",
          showMore: "Показати більше",
          showLess: "Показати менше",
          searchPlaceholder: "Введіть назву відео",
          videoNotFound: 'Відео з назвою "" не знайдено',
          noVideosForFilters: "Відео не знайдено для вибраних фільтрів",
          allVideos: "Всі відео",
          grammar: {
            verb: "Дієслово",
            infinitive: "Інфінітив",
            thirdPersonSingular: "3 ос. одн.",
            pastTense: "Минулий час",
            pastParticiple: "Дієприкм. мин. часу",

            adjective: "Прикметник",
            adverb: "Прислівник",
            comparative: "Вищий ступінь",
            superlative: "Найвищий ступінь",

            pronoun: "Займенник",
            reflexiveForm: "Зворотна форма",
            objectForm: "Об'єктна форма",
            possessiveForm: "Присвійна форма",

            determiner: "Визначник",
            singular: "Однина",
            plural: "Множина",

            number: "Числівник",

            abbreviation: "Абревіатура",
            fullForm: "Повна форма",
            yes: "так",
            no: "ні",
          },
          "English": "Англійська",
          "Polski": "Польська",
          "Українська": "Українська",
          "Ukrainian": "Українська",
          "Polish": "Польська",
          "My learning": "Моє навчання",
          "All Videos": "Усі відео",
          "Words learned": "Вивчених слів",
          "Videos completed": "Завершених відео",
          "Questions answered correctly": "Правильних відповідей на запитання",
          "Dialogues role played successfully": "Успішно виконаних діалогів",
          "All My Videos": "Усі мої відео",
          "In Progress": "У процесі",
          "Completed": "Завершено",
          "❤️ Favorites": "❤️ Вибране",
          "words": "слів",
          "word": "слово",
          "Total Words": "Всього слів",
          "Words in Dictionary": "Слів у словнику",
          "Watch Video": "Дивись відео",
          "Watch the full lesson video": "Перегляньте повне відео уроку",
          "Study Words": "Вчити слова",
          "Learn vocabulary in context": "Вивчайте словниковий запас у контексті",
          "Check Understanding": "Перевірити розуміння",
          "Test your comprehension": "Перевірте своє розуміння",
          "Practice Dialogues": "Практикувати діалоги",
          "Real-life conversations": "Розмови з реального життя",
          "Example": "Приклад",
          "Common Mistakes": "Поширені Помилки",
          "Log Out": "Вийти",
          "Log In": "Увійти",
          "days remaining": "днів залишилось",
          "Welcome back": "З поверненням",
          "Language level": "Рівень мови",
          "Travel": "Подорожі",
          "Education": "Освіта",
          "Work": "Робота",
          "Health": "Здоров'я",
          "News & Technology": "Новини та технології",
          "Leisure": "Дозвілля",
          "Daily Life": "Повсякденне життя",
          "Beginner": "Початковий",
          "Elementary": "Елементарний",
          "Intermediate": "Середній",
          "Upper-Intermediate": "Вище середнього",
          "Advanced": "Високий",
          "Proficiency": "Професійний",
          "INF": "ІНФ",
          "V2": "V2",
          "V3": "V3",
          "3 SG": "3 одн.",
          "SG": "одн.",
          "PL": "мн.",
          "BASE": "ОСНОВА",
          "COMP": "ПОРІВ",
          "SUP": "НАЙВ",
          "REFL": "ЗВОРОТ",
          "OBJ": "ОБ'ЄКТ",
          "POSS": "ПРИСВ",
          "FULL": "ПОВНА",
          "Master Your English!": "Виведіть свою англійську на новий рівень",
          "Start Testing": "Розпочати тест",
          "Choose your challenge:": "Оберіть тип завдання:",
          "Yes/No Questions": "Питання Так/Ні",
          "Text/Voice Response": "Відповідь текстом/голосом",
          "Drag & Drop": "Перетягування",
          "Attempts": "Спроб",
          "attempts": "спроби",
          "Click any question to jump directly to it!": "Натисніть на будь‑яке запитання, щоб перейти до нього",
          "View Results": "Переглянути результати",
          "Question": "Питання",
          "Hint": "Підказка",
          "of": "з",
          "Select your answer – it will be checked automatically": "Виберіть відповідь — її буде перевірено автоматично",
          "YES": "ТАК",
          "NO": "НІ",
          "Correct": "Правильно",
          "Incorrect": "Неправильно",
          "Partially Correct": "Частково правильно",
          "Next Question": "Наступне питання",
          "Answer by Text or Voice": "Відповідайте текстом або голосом",
          "Type your answer below or click the microphone to record your voice": "Введіть відповідь нижче або натисніть мікрофон, щоб записати свій голос",
          "Type your answer here…": "Введіть відповідь тут…",
          "Ready": "Готово",
          "Answered": "Відповів",
          "Check Answer": "Перевірити відповідь",
          "Recording...": "Запис…",
          "Your answer:": "Ваша відповідь:",
          "Drag the words to complete the sentence:": "Перетягніть слова, щоб доповнити речення:",
          "Your answer will be checked automatically when all gaps are filled": "Відповідь перевіриться автоматично, як тільки ви заповните всі пропуски",
          "Next Question": "Наступне питання",
          "Finish Test": "Завершити тест",
          "Please select at least one test type!": "Будь ласка, виберіть принаймні один тип тесту!",
          "No questions available!": "Немає доступних питань!",
          "Loading questions...": "Завантаження питань...",
          "This may take 5-10 seconds for new content": "Це може зайняти 5-10 секунд для нового контенту",
          "of": "з",
          "Try Again": "Спробувати ще раз",
          "Scroll down to see your detailed error analysis": "Прокрутіть униз, щоб переглянути детальний аналіз помилок",
          "Outstanding": "Відмінно!",
          "Keep Growing!": "Зростайте далі!",
          "Great Job!": "Чудова робота!",
          "Good Effort!": "Гарне зусилля!",
          "Error Analysis": "Аналіз помилок",
          "Understanding your mistakes helps you learn better": "Розуміння своїх помилок допомагає вчитися краще",
          "Key Areas for Improvement": "Ключові напрями для вдосконалення",
          "Incorrect Answers": "Неправильні відповіді",
          "Partially Correct Answers": "Частково правильні відповіді",
          "Correct answer:": "Правильна відповідь:",
          "You've mastered this material! Your understanding is exceptional.": "Ви опанували цей матеріал! Ваше розуміння — виняткове.",
          "Every expert was once a beginner. Keep practicing and you'll get there!": "Кожен експерт колись був початківцем. Продовжуйте практикуватися — і все вийде!",
          "You've completed your": "Ви використали",
          "You're doing really well! Keep up the excellent work.": "У тебе чудово виходить! Продовжуй у тому ж дусі.",
          "You're making progress! A little more practice will help you improve.": "Ти досягаєш прогресу! Трохи більше практики допоможе тобі стати кращим.",
          "Focus on careful reading - multiple Yes/No questions were missed. Pay attention to keywords like 'not', 'only', or 'all'.": "Зосередьтеся на уважному читанні — пропущено кілька питань Так/Ні. Звертайте увагу на ключові слова, як-от 'не', 'тільки' або 'всі'.",
          "Practice word order and grammar structures - drag & drop questions show gaps in understanding sentence construction.": "Практикуйте порядок слів і граматичні структури — завдання з перетягуванням показують прогалини в розумінні побудови речень.",
          "Work on expressing complete thoughts - text/voice answers need more detail and accuracy.": "Працюйте над вираженням повних думок — текстові/голосові відповіді потребують більше деталей і точності.",
          "Consider reviewing the material more thoroughly before attempting again. Take notes on key concepts.": "Розгляньте можливість більш ретельного вивчення матеріалу перед повторною спробою. Робіть нотатки з ключових концепцій.",
          "You're showing good understanding but need to refine some details. Focus on the specific areas mentioned above.": "Ви демонструєте гарне розуміння, але потрібно уточнити деякі деталі. Зосередьтеся на конкретних областях, згаданих вище.",
          "No answer": "Немає відповіді",
          "No answer provided": "Відповідь не надано",
          "N/A": "Н/Д",
          "See explanation": "Дивіться пояснення",
          "Review Your Answer": "Переглянути вашу відповідь",
          "See your answer and the explanation for this question": "Подивіться свою відповідь і пояснення до цього питання",
          "← Back to Results": "← Назад до результатів",
          "Review Mode": "Режим перегляду",
          "Review all your answers and explanations": "Переглянути всі ваші відповіді та пояснення",
          "Previous": "Попередній",
          "Next": "Наступний",
          "Please provide an answer!": "Будь ласка, надайте відповідь!",
          "Microphone access denied. Please type your answer.": "Доступ до мікрофона заборонено. Будь ласка, введіть відповідь.",
          "Mic denied": "Мікрофон заборонено",
          "Voice recording saved": "Голосовий запис збережено",
          "Failed to submit your recording. Please try again.": "Не вдалося надіслати ваш запис. Будь ласка, спробуйте ще раз.",
          "Failed to play recording": "Не вдалося відтворити запис",
          "Voice recording transcribed": "Голосовий запис розшифровано",
          "Voice recording submitted": "Голосовий запис надіслано",
          "Processing...": "Обробка...",
          "Welcome to Dialogue Studio!": "Ласкаво просимо до Dialogue Studio!",
          "firstPopDes": "Давай потренуємо діалог разом. Вам потрібно використати 5 слів з словника у нашій розмові.",
          "Yes, I'm Ready!": "ТАК, Я ГОТОВИЙ!",
          "FINISH SESSION": "ЗАВЕРШИТИ УРОК",
          "Word Treasury": "Слова",
          "YOUR PROGRESS": "ВАШ ПРОГРЕС",
          "Words Used": "Використані слова",
          "PRESS TO SPEAK": "НАТИСНІТЬ, ЩОБ ГОВОРИТИ",
          "Listening to you...": "Слухаю тебе...",
          "I don't understand the question": "Я не розумію питання",
          "I can't answer": "Я не можу відповісти",
          "Time Invested": "Витрачений час",
          "Time Spent": "Витрачено часу",
          "Welcome to your": "Ласкаво просимо до вашої",
          "restFirstMessageT": "практики діалогу! Я з нетерпінням хочу обговорити з вами цю тему. Спробуйте використати 5 слів, показаних праворуч.",
          "Exchanges": "Обміни",
          "Words Mastered": "Слів опановано",
          "Brilliant Session!": "Блискучий урок",
          "You've created something beautiful with words today": "Ви сьогодні створили щось прекрасне за допомогою слів",
          "Your Achievements": "Ваші досягнення",
          "Perfect! You used all 5 vocabulary words brilliantly!": "Чудово! Ви блискуче використали всі 5 слів зі словника!",
          "New Adventure": "Нова пригода",
          "Exit": "Вихід",
          "Welcome Back!": "З поверненням!",
          "You have an unfinished dialogue session for": "У вас є незакінчений діалог на тему",
          "You've used": "Ви використали",
          "out of 5 vocabulary words.": "слово з 5 слів словникового запасу",
          "Continue Session": "Продовжити діалог",
          "Start Over": "Почати спочатку",
          "In which language would you like to view the website?": "Якою мовою ви б хотіли переглядати сайт?",
          "Take the test — get a program personalized to your goal and level": "Пройдіть тест — отримаєте програму під вашу мету та рівень",
          "It will take less than 1 minute": "Це займе менше 1 хвилини",
          "Quick & Easy": "Швидко та легко",
          "Step 1 of 2": "Крок 1 з 2",
          "Step 2 of 2": "Крок 2 з 2",
          "What is your current English level?": "Який ваш поточний рівень англійської?",
          "What's your main goal with English?": "Яка ваша основна мета у вивченні англійської мови?",
          "Great! We've prepared your personalized learning path": "Чудово! Ми підготували ваш персоналізований шлях навчання",
          "Finish test": "Завершити тест",
          "English Learning Journey": "Подорож вивчення англійської",
          "Lower Level": "Знизити рівень",
          "Add Plan": "Додати план",
          "Raise Level": "Підвищити рівень",
          "Learning Progress": "Прогрес навчання",
          "Current Level": "Поточний рівень",
          "Basics": "Основи",
          "Conversations": "Розмови",
          "Introduction": "Знайомство",
          "Greetings": "Привітання",
          "Practice": "Практика",
          "Daily Talk": "Щоденні розмови",
          "Questions": "Питання",
          "Social": "Соціальне",
          "Business": "Бізнес",
          "Emails": "Електронні листи",
          "Meetings": "Зустрічі",
          "Airport": "Аеропорт",
          "Hotels": "Готелі",
          "Dining": "Їжа",
          "Grammar": "Граматика",
          "Idioms": "Ідіоми",
          "Fluency": "Вільне володіння",
          "I want to choose the video myself": "Я хочу вибрати відео самостійно",
          "Continue Learning": "Продовжити навчання",
          "TRY 2-MIN DEMO": "Спробуй 2-хвилинну демо",
          "WHY CHOOSE AI LINGUA?": "Чому обрати AI Lingua?",
          "REAL-LIFE VIDEOS": "Відео з реального життя",
          "AI-POWERED PRACTICE": "Практика з ШІ",
          "ALL LEVELS WELCOME": "Для всіх рівнів",
          // Level descriptions
          "Preparatory course. Ideal for beginners": "Підготовчий курс. Ідеально для початківців",
          "I am starting to learn English.": "Я починаю вивчати англійську.",
          "I already know some words": "Я вже знаю деякі слова",
          "I can already speak a little": "Я вже можу трохи говорити",
          "I confidently speak on various topics": "Я впевнено говорю на різні теми",
          "I can discuss various topics in detail": "Я можу детально обговорювати різні теми",
          "Enter your credentials to access your account": "Введіть ваші дані для входу в систему",
          "coming soon": "дуже скоро",
          "Login successful": "Успішний вхід",
          "Login failed": "Помилка входу",
          "Create your account to get started": "Створіть акаунт, щоб розпочати",
          "Plans that fit your needs": "Оберіть план під свої потреби",
          "Simple, scalable pricing that grows with you.": "Прості й гнучкі тарифи, що зростають разом із вами.",
          "Free": "Безкоштовний",
          "Free for everyone": "Безкоштовно для всіх",
          "Watch learning videos": "Перегляд навчальних відео",
          "Add words to personal vocabulary": "Додавання слів до особистого словника",
          "Study & review words": "Вивчення та повторення слів",
          "Video comprehension checks": "Тести на розуміння відео",
          "AI voice dialogues": "Голосові діалоги зі ШІ",
          "Certificate upon completion": "Сертифікат після завершення",
          "Priority support": "Пріоритетна підтримка",
          "Sign Up": "Зареєструватися",
          "/month": "/місяць",
          "Plans that fit your needs": "Плани, що відповідають вашим потребам",
          "Simple, scalable pricing that grows with you.": "Просте масштабоване ціноутворення, яке зростає разом з вами",
          "Free": "Безкоштовно",
          "Free for everyone": "Безкоштовно для всіх",
          "Watch learning videos": "Перегляд навчальних відео",
          "Add words to personal vocabulary": "Додавання слів до особистого словника",
          "Study & review words": "Вивчення та повторення слів",
          "Video comprehension checks": "Тести на розуміння відео",
          "AI voice dialogues": "Голосові діалоги зі ШІ",
          "Certificate upon completion": "Сертифікат після завершення",
          "Priority support": "Пріоритетна підтримка",
          "For individuals & freelancers": "Для індивідуальних користувачів і фрилансерів",
          "7 days free trial": "7 днів безкоштовного пробного періоду",
          "AI voice dialogues — 10 per day": "Голосові діалоги зі ШІ — 10 на день",
          "Unlimited AI voice dialogues": "Необмежені голосові діалоги зі ШІ",
          "For teams & agencies": "Для команд і агенцій",
          "For schools, businesses, universities": "Для шкіл, компаній та університетів",
          "All Pro features included": "Усі можливості тарифу «Професійний»",
          "Per-user progress reports": "Звіти про прогрес для кожного користувача",
          "Training reminders for learners": "Нагадування про навчання для користувачів",
          "Custom branding options": "Налаштування фірмового стилю",
          "Dedicated account manager": "Персональний менеджер",
          "Volume discounts available": "Доступні знижки за обсяг",
          "API access & integrations": "Доступ до API та інтеграції",
          "Contact Us": "Зв'язатися з нами",
          "Get Started": "Почати",
          "Custom Pricing": "Індивідуальна ціна",
          "Pro": "Професійний",
          "Popular": "Популярний",
          "Cancel & Refund Policy": "Політика скасування та повернення коштів",
          "Pricing": "Тарифи",
          "All rights reserved": "Всі права захищені",
          "Terms of Use": "Умови використання",
          "Privacy Policy": "Політика конфіденційності",
          "Cookie Settings": "Налаштування cookie",
          "Terms of Use2": "Умови користування",
          "Last updated": "Останнє оновлення",
          "temrs1Text": "AI Lingua — онлайн-платформа для вивчення англійської мови (відеоуроки, словник, тести на розуміння, тренування діалогів зі штучним інтелектом). Доступ надається виключно в цифровій формі; фізичні товари не постачаються.",
          "terms2": "Платежі обробляє Paddle.com; інвойси/чеки та застосовні податки адмініструє Paddle.",
          "terms3": "Власник сервісу: ФОП Корчинська Альона Олександрівна (Korchynska Alona Oleksandrivna)",
          "terms4": "| Юрисдикція: Україна",
          "terms5": "Адреса для листування: м. Старокостянтинів, Хмельницька область, 31100, Україна",
          "terms6": "Мінімальний вік користувача — 13 років; особи молодші 13 не можуть користуватися сервісом. Якщо ви проживаєте у країні ЄС/ЄЕЗ або Великій Британії і вам менше 16 років, потрібна підтверджена згода батьків/опікунів (якщо закон вашої країни дозволяє нижчий вік згоди, ми це врахуємо). Користувач зобов'язаний забезпечувати конфіденційність облікових даних і не передавати доступ третім особам.",
          "terms7": "Paddle.com Acting as Merchant of Record.",
          "terms8": "Оплату приймає та інвойси/чеки виставляє Paddle.com як продавець/merchant of record, включно з розрахунком і стягненням застосовних податків/ПДВ. Плани та ціни публікуються на сторінці тарифів і можуть змінюватися з попереднім повідомленням, якщо впливають на наступні періоди. Підписка авто-поновлюється, доки її не скасовано у кабінеті користувача (автопродовження вимикається; доступ діє до кінця оплаченого періоду).",
          "terms9": "Пробний період — 7 днів. Якщо підписку оформлено під час trial, оплачений доступ починається одразу, а пробний триває до завершення 7 днів (загальний доступ не подвоюється). Доступна безкоштовна версія з обмеженим функціоналом.",
          "terms10": "Повернення коштів після оплати підписки не надаються, включно з частковими/пропорційними сумами, за винятком випадків, прямо передбачених імперативними нормами застосовного законодавства або нашою політикою винятків.",
          "terms11": "Забороняються: порушення законодавства; агресивний, дискримінаційний або шкідливий контент; спроби несанкціонованого доступу, втручання в роботу сервісу або реверс-інжиніринг; автоматизований масовий збір даних; шахрайство з платежами; спільне використання одного акаунта кількома особами; завантаження або введення матеріалів, що порушують права ІВ третіх осіб. Акаунти, що порушують ці Умови, можуть бути обмежені або закриті після повідомлення, де це можливо.",
          "terms12": "Матеріали сервісу (зокрема відео, тести, програмний код, дизайн, тексти) захищені правами інтелектуальної власності. Користувачеві надається обмежена, невиключна, непередавана ліцензія на особисте некомерційне використання сервісу. Контент, завантажений користувачем, залишається його власністю; користувач надає сервісу обмежену ліцензію на використання такого контенту з метою надання та поліпшення сервісу.",
          "terms13": "Ми залучаємо сторонніх постачальників (хостинг, аналітика, LLM-моделі для діалогів зі ШІ). Дані обробляються лише для надання, підтримки та поліпшення сервісу. Ми не використовуємо ваш вміст для навчання загальних моделей провайдерів, якщо прямо не вкажемо інше і не отримаємо вашу згоду. Перелік ключових постачальників та місцезнаходження серверів наведено у Політиці конфіденційності.",
          "terms14": "Ми можемо оновлювати функції, ціни та умови. Про суттєві зміни, що впливають на оплату/доступ, повідомляємо щонайменше за 7 днів (e-mail/банер у акаунті). Продовження користування після дати набуття чинності означає згоду з оновленими умовами.",
          "terms15": "Сервіс може призупинити або припинити доступ користувача в разі порушення цих Умов або за наявності безпекових/правових підстав, із розумним повідомленням, коли це можливо. Після припинення доступу ви можете експортувати свої дані протягом 30 днів (крім випадків правових обмежень).",
          "terms16": "Сервіс надається «як є» та «як доступний». У межах, дозволених законом, не надаються будь-які неявні гарантії придатності чи відповідності конкретній меті. Сукупна відповідальність власника сервісу перед користувачем обмежується сумою платежів, сплачених таким користувачем за останні 12 місяців.",
          "terms17": "Ці Умови регулюються законодавством України; спори підвідомчі компетентним судам України, якщо інше не передбачено імперативними нормами.",
          "terms18": "Питання щодо сервісу та білінгу (включно з відмовою від підписки):",
          "About Us": "Про нас",
          "Accounts and Age": "Облікові записи та вік",
          "Subscriptions, Pricing, and Billing": "Підписки, ціни та білінг",
          "Trial Period and Free Version": "Пробний період і безкоштовна версія",
          "Refunds": "Повернення коштів",
          "Acceptable Use": "Прийнятне використання",
          "Intellectual Property Rights": "Права інтелектуальної власності",
          "Third-Party Technologies and AI": "Сторонні технології та ШІ",
          "Service Availability and Changes": "Доступність та зміни сервісу і цін",
          "Termination of Access": "Припинення доступу",
          "Warranty Disclaimer": "Відмова від гарантій та обмеження відповідальності",
          "Governing Law and Contact": "Право, юрисдикція та зв'язок",
          "October": "жовтня",
          "Who We Are": "Хто ми",
          "privacy1": "ФОП Корчинська Альона Олександрівна — контролер даних для AI Lingua. Контакти:",
          "Data We Process": "Дані, які ми обробляємо",
          "privacy2": "email, пароль (хешований), ім'я/псевдонім.",
          "privacy3": "прогрес, результати тестів, налаштування, журнали активності.",
          "privacy4": "обробляє Paddle.com (ми отримуємо статус транзакції/підписки, Order ID; не зберігаємо повні реквізити карток).",
          "privacy5": "cookie/телеметрія для роботи сайту, безпеки, аналітики.",
          "Purposes": "Для чого",
          "privacy6": "Надання сервісу, білінг, підтримка, безпека, аналітика/поліпшення, виконання правових обов'язків.",
          "Legal Bases": "Правові підстави",
          "privacy7": "Виконання договору; законний інтерес; згода (де потрібно); правовий обов'язок.",
          "Data Sharing": "Передача даних",
          "privacy8": "Постачальникам інфраструктури/аналітики та Paddle.com — з належними гарантіями.",
          "privacy8.1": "Постачальникам інфраструктури/аналітики та",
          "privacy8.2": "— з належними гарантіями.",
          "Retention": "Зберігання",
          "privacy9": "Поки активний акаунт; окремі записи — довше, якщо цього вимагає закон (напр., фінзвітність).",
          "Data Subject Rights": "Права суб'єкта даних",
          "privacy10": "Запити щодо доступу/видалення/перенесення/заперечення надсилайте на ailinguaservice@gmail.com. Ми відповідаємо протягом 30 днів. Ви також маєте право звернутися зі скаргою до Уповноваженого ВРУ з прав людини або до наглядового органу у вашій країні проживання.",
          "International Transfers": "Міжнародні передачі",
          "privacy11": "Коли ми передаємо дані за межі України/ЄС, ми використовуємо стандартні договірні положення (SCC) або інші належні гарантії. Перелік основних постачальників і країни обробки наводяться у відповідному розділі/додатку.",
          "Cookies": "Cookies",
          "privacy12": "Ми застосовуємо необхідні cookies для роботи сайту та аналітичні/маркетингові — лише за вашою згодою. Ви можете змінити вибір у банері згоди у будь-який момент.",
          "Account": "Акаунт",
          "Learning": "Навчання",
          "Payments": "Платежі",
          "Technical": "Технічні",
          "Cancellation and Refund Policy": "Політика скасування та повернення коштів",
          "refund1": "7 днів. Якщо оформлено підписку під час trial, пробний доступ діє до завершення 7 днів.",
          "refund2": "списання через Paddle; підписка автопродовжується до скасування.",
          "refund3": "будь-коли у вашому кабінеті/через Paddle; після скасування доступ зберігається до кінця вже оплаченого періоду.",
          "refund4": "не надаються після оплати підписки (включно з частковими/пропорційними), за винятком випадків, які прямо вимагає чинне законодавство.",
          "refund5": "Контакти з питань білінгу/скасування:",
          "Trial period:": "Пробний період:",
          "Payment and auto-renewal:": "Оплата і автопродовження:",
          "CNCL": "Скасування:",
          "RFND": "Повернення коштів:",
          "app-header-text": "Зараз попрактикуємо діалог з відео. Говоримо так само, як у ролику: ті ж слова й та сама тема. Починаємо.",
          "Try saying it like this:": "Спробуй сказати так:",
          "Keep practicing!": "Продовжуйте практикуватися!",
          "Not bad!": "Непогано!",
          "Good job!": "Молодець!",
          "Excellent result!": "Відмінний результат!",
          "Skip": "Пропустити",
          "Take a break and review!": "Зробімо паузу та повторимо!",
          "You\'ve tried five times already - that\'s great persistence! But it seems like it would be worth refreshing the material so the dialogue goes easier.": "Ви вже п'ять разів спробували — це класна наполегливість! Але здається, варто освіжити матеріал, щоб діалог пішов легше.",
          "Mistakes are part of learning": "Помилки – це частина навчання",
          "Nothing scary, it happens!": "Нічого страшного, буває!",
          "It seems difficult to answer by voice for now. Let\'s first review the material again - after that it will be much easier!": "Здається, поки складно відповідати голосом. Давайте спершу ще раз переглянемо матеріал — після цього буде набагато простіше!",
          "One step back is two steps forward": "Один крок назад - це два кроки вперед",
          "We recommend returning to:": "Рекомендуємо повернутися до:",
          "Learn Words2": "Вчити слів",
          "Review key words and phrases from the lesson": "Повторити ключові слова та фрази уроку",
          "Watch Video2": "Дивитись відео",
          "Watch the dialogue again with subtitles": "Переглянути діалог ще раз з субтитрами",
          "I want to continue the dialogue": "Хочу продовжити діалог",
          "Lesson completed": "Урок завершено",
          "Great! Lesson": "Чудово! Урок",
          "completed!": "пройдено!",
          "You\'ve completed the dialogue practice for this video. You can now move on to the next lesson or review this one again.": "Ти успішно відпрацював діалог і вже можеш переходити до наступного уроку. Так тримати!",
          "Repeat Lesson": "Повторити урок",
          "Next Lesson": "Наступний урок",
          "Almost there!": "Майже вийшло!",
          "Don't be sad": "Не засмучуйся",
          "Every attempt": "кожна спроба",
          "is a step forward": "наближає до успіху",
          "This time the lesson": "Цього разу урок",
          "was not completed — but that's okay. Mistakes are part of learning. Repeat the lesson or move on: your choice!": "не вдалося завершити — але це нормально. Помилки — це частина навчання. Повтори урок або рухайся далі: вибір за тобою!",
          "Awesome plan for you": "Чудовий план для тебе",
          "Access to 30 video pack": "Доступ до пакету з 30 відео",
          "Subscriptions": "Підписки",
          "Sign in to manage your subscription": "Увійдіть, щоб керувати своєю підпискою",
          "Please log in to view and manage your subscription details, billing information, and account settings.": "Будь ласка, увійдіть, щоб переглянути та керувати інформацією про підписку, платіжною інформацією та налаштуваннями облікового запису.",
          "You can manage your billing information and subscription here": "Ви можете керувати своєю платіжною інформацією та підпискою тут",
          "You're on the": "Ви на",
          "plan": "плані",
          "Next renewal:": "Наступне оновлення:",
          "Plan cost": "Вартість плану",
          "Status": "Статус",
          "Auto-renewal": "Автопродовжування",
          "Cancel Subscription": "Відмінити підписку",
          "Upgrade your plan": "Покращити ваш план",
          "Processing payment": "Обробка оплати",
          "We are waiting for confirmation from the payment provider...": "Очікуємо підтвердження від платіжного провайдера...",
          "Your subscription plan": "Тарифний план",
          "Activation progress": "Прогрес активації",
          "Do not close this page - we will notify you immediately": "Не закривайте цю сторінку — ми повідомимо вас одразу",
          "Successfully activated!": "Успішно активовано!",
          "Your subscription plan": "Ваш тарифний план",
          "Do not waste time - let's learn together! All features of the plan": "Не гайте часу — нумо вчитись разом! Всі функції плану",
          "are already available in your account.": "доступні у вашому акаунті.",
          "Thank you for trusting AI Lingua!": "Дякуємо за довіру до AI Lingua!",
          "Subscription": "Підписка",
          "Tel": "Тел",
          "Стандарт": "Стандарт",
          "Преміум": "Преміум",
          "After registration, you'll get your personalized course and be able to track your progress.": "Після реєстрації ви отримаєте персоналізований курс і зможете відстежувати свій прогрес",
          "Start your language learning journey with AI-powered lessons tailored just for you!": "Почніть свою подорож вивчення мови з уроків на базі штучного інтелекту, розроблених спеціально для вас!",
          "Welcome Back, aliona!": "З поверненням, Альона!",
          "Let's continue studying together": "Давайте продовжувати навчання разом",
          "Learned Words": "Вивчених слів",
          "Completed Videos": "Завершених відео",
          "Correct Answers": "Правильних відповідей",
          "Successful Dialogues": "Успішних діалогів",
          "My Courses": "Мої курси",
          "View all courses": "Переглянути всі курси",
          "Business English": "Ділова англійська",
          "Intermediate": "Середній",
          "24 lessons": "24 уроків",
          "Progress": "Прогрес",
          "lessons done": "уроків виконано",
          "lessons left": "уроків залишилося",
          "Conversational English": "Розмовна англійська",
          "30 lessons": "30 уроків",
          "Travel English": "Англійська для подорожей",
          "15 lessons": "15 уроків",
          "My Videos": "Мої відео",
          "View all": "Переглянути всі",
          "Name": "Ім'я",
          "Email": "Email",
          "Phone": "Телефон",
          "Message": "Повідомлення",
          "Submit": "Надіслати",
          "Please fill in all the fields!": "Будь ласка, заповніть усі поля!",
          "Completed Dialogs": "Завершених діалогів",
          "Введіть коректну адресу електронної пошти.": "Введіть коректну адресу електронної пошти.",
          "The email address and/or password you specified are not correct.": "Вказані вами адреса електронної пошти та/або пароль неправильні.",
          "Choose a username": "Виберіть ім'я користувача",
          "Це поле обов'язкове.": "Це поле обов'язкове.",
          "A user is already registered with this email address.": "Користувач вже зареєстрований з цією адресою електронної пошти.",
          "Register to save your progress": "Зареєструйтесь, щоб зберегти свій прогрес",
          "Register": "Зареєструватись",
          "Previous Lesson": "Попередній урок",
          "Lesson Completed": "Урок завершено",
          "Lesson Not Completed": "Урок не завершено",
          "Email must contain @": "Електронна адреса повинна містити @",
          "Email must contain . (dot)": "Електронна адреса повинна містити . (крапку)",
          "Invalid email format (example@domain.com)": "Недійсний формат електронної пошти (example@domain.com)",
          "At least 8 characters": "Принаймні 8 символів",
          "Must contain letters": "Повинно містити літери",
          "Must contain numbers": "Має містити цифри",
        },
      },
      pl: {
        translation: {
          welcome: "Witamy! Wybierz swój język:",
          level: "Jaki jest Twój poziom angielskiego?",
          purpose: "Dlaczego uczysz się angielskiego?",
          videos: "Oto kilka filmów dla Ciebie:",
          register: "Zarejestruj się, aby kontynuować",
          options: {
            beginner: "Jeszcze nic nie wiem",
            elementary: "Podstawowy",
            intermediate: "Średnio zaawansowany",
            advanced: "Zaawansowany",
            travel: "Przygotowanie do podróży",
            job: "Na rozmowy kwalifikacyjne",
            education: "Cele edukacyjne",
            communication: "Aby komunikować się z ludźmi",
            fun: "Dla zabawy",
          },
          aboutUs: "O nas",
          contact: "Kontakt",
          services: "Usługi",
          blog: "Blog",
          catalog: "Katalog",
          buyNow: "Kup teraz",
          addToCart: "Dodaj do koszyka",
          checkout: "Zamówienie",
          totalPrice: "Łączna cena",
          search: "Szukaj",
          enterYourEmail: "Wpisz swój email",
          subscribe: "Subskrybuj",
          latestNews: "Najnowsze wiadomości",
          readMore: "Czytaj więcej",
          sendMessage: "Wyślij wiadomość",
          name: "Imię",
          email: "Email",
          message: "Wiadomość",
          submit: "Prześlij",
          loading: "Ładowanie...",
          "Loading...": "Ładowanie...",
          success: "Sukces!",
          error: "Wystąpił błąd. Spróbuj ponownie.",
          signin: "Zaloguj się",
          password: "Hasło",
          forgotpassword: "Zapomniałeś hasła",
          oro: "lub",
          account: "Nie masz konta?",
          register: "Rejestracja",
          login: "Zaloguj się",
          loading: "Ładowanie",
          signup: "Rejestracja",
          username: "Nazwa użytkownika",
          confirmpassword: "Potwierdź hasło",
          haveac: "Masz już konto?",
          logout: "Wyloguj się",
          registerforfree: "Zarejestruj się za darmo",
          "Start speaking with confidence from day one": "Zacznij mówić pewnie od pierwszego dnia",
          "Start Learning Free": "ZACZNIJ NAUKĘ ZA DARMO",
          "Choose your English level and topics that interest you": "Wybierz swój poziom angielskiego i tematy, które Cię interesują",
          "All Categories": "Wszystkie kategorie",
          "All Levels": "Wszystkie poziomy",
          "Search videos by title": "Szukaj filmów po tytule",
          "Immerse yourself in authentic content featuring real-life videos with practical, everyday vocabulary you'll actually use.": "Zanurz się w autentycznych treściach z prawdziwymi filmami i praktycznym, codziennym słownictwem, którego naprawdę użyjesz.",
          "Learn Words": "Ucz się słów",
          "Focus your energy efficiently by studying only the words from videos that are new to you, maximizing your learning time.": "Skup swoją energię efektywnie, ucząc się tylko tych słów z filmów, które są dla Ciebie nowe, maksymalizując czas nauki.",
          "understanding2": "Sprawdź zrozumienie",
          "Assess your comprehension through interactive questions, voice-based answers, and targeted review of new vocabulary.": "Oceń swoje zrozumienie dzięki interaktywnym pytaniom, odpowiedziom głosowym i ukierunkowanemu powtarzaniu nowego słownictwa.",
          "practiceDialogues2": "Ćwicz dialogi",
          "Apply your knowledge in realistic conversations based on the videos you've watched, building confidence for real-world interactions": "Zastosuj swoją wiedzę w realistycznych rozmowach opartych na obejrzanych filmach, budując pewność siebie w prawdziwych sytuacjach.",
          watch: "Ucz się nowych słów",
          watchbig:
            "Twórz własny słownik lub pozwól AI dobrać najważniejsze słowa dla Ciebie.",
          learn: "Oglądaj filmy",
          learnBig:
            "Zanurz się w autentyczne dialogi dopasowane do Twojego poziomu i celów.",
          speak: "Dyskutuj",
          speakBig:
            "Ćwicz konwersacje z AI – tekstowo lub głosowo, jak w prawdziwej rozmowie.",
          discuss: "Otrzymaj informację zwrotną na swoje odpowiedzi",
          discussBig:
            "AI sprawdza Twoje odpowiedzi, wyjaśnia błędy i pomaga Ci się rozwijać.",
          popularVideo: "Popularne wideo",
          allLevels: "Wszystkie poziomy",
          showAll: "Pokaż wszystko",
          filter: "Filtr",
          chooseLanguage: "W jakim języku wygodnie jest Ci przeglądać stronę?",
          popupTitle: "Czy chcesz rozpocząć naukę?",
          startLearning: "Rozpocznij",
          startyFirstTitle: "Mów językami świata",
          levelonea: "Początkujący",
          leveltwoa: "Podstawowy",
          levevoneb: "Średnio zaawansowany",
          lebeltwob: "Wyższy średnio zaawansowany",
          levelonec: "Zaawansowany",
          leveltwoc: "Biegły",
          levelBeginnerGroup: "Początkujący",
          levelIntermediateGroup: "Średnio zaawansowany",
          levelAdvancedGroup: "Zaawansowany",
          allLevelsOption: "Wszystkie poziomy",
          contButton: "Kontynuuj",
          pojasn: "Wyjaśnienie",
          pruklad: "Przykład użycia",
          showMore: "Pokaż więcej",
          showLess: "Pokaż mniej",
          searchPlaceholder: "Wpisz tytuł wideo",
          videoNotFound: 'Nie znaleziono wideo o tytule ""',
          noVideosForFilters: "Nie znaleziono wideo dla wybranych filtrów",
          allVideos: "Wszystkie filmy",
          "English": "Angielski",
          "Polski": "Polski",
          "Українська": "Ukraiński",
          "Ukrainian": "Ukraiński",
          "Polish": "Polski",
          "My learning": "Moja nauka",
          "All Videos": "Wszystkie filmy",
          "Words learned": "Nauczonych słów",
          "Videos completed": "Ukończonych filmów",
          "Questions answered correctly": "Poprawnych odpowiedzi na pytania",
          "Dialogues role played successfully": "Pomyślnie odegranych dialogów",
          "All My Videos": "Wszystkie moje filmy",
          "In Progress": "W toku",
          "Completed": "Ukończone",
          "❤️ Favorites": "❤️ Ulubione",
          "words": "słów",
          "word": "słowo",
          "Total Words": "Łączna słów",
          "Words in Dictionary": "Słowa w słowniku",
          "Watch Video": "Oglądaj film",
          "Watch the full lesson video": "Obejrzyj cały film z lekcją",
          "Study Words": "Uczyć się słówek",
          "Learn vocabulary in context": "Ucz się słownictwa w kontekście",
          "Check Understanding": "Sprawdzić zrozumienie",
          "Test your comprehension": "Sprawdź swoje zrozumienie",
          "Practice Dialogues": "Ćwiczyć dialogi",
          "Real-life conversations": "Rozmowy w prawdziwym życiu",
          "Example": "Przykład",
          "Common Mistakes": "Typowe Błędy",
          "Log Out": "Wyloguj się",
          "Log In": "Zaloguj się",
          "days remaining": "pozostało dni",
          "Welcome back": "Witamy ponownie",
          "Language level": "Poziom języka",
          "Travel": "Podróże",
          "Education": "Edukacja",
          "Work": "Praca",
          "Health": "Zdrowie",
          "News & Technology": "Wiadomości i technologia",
          "Leisure": "Czas wolny",
          "Daily Life": "Codzienne życie",
          "Beginner": "Początkujący",
          "Elementary": "Podstawowy",
          "Intermediate": "Średnio zaawansowany",
          "Upper-Intermediate": "Wyższy średnio zaawansowany",
          "Advanced": "Zaawansowany",
          "Proficiency": "Biegły",
          "INF": "INF",
          "V2": "PS",
          "V3": "PP",
          "3 SG": "3 os.l.poj.",
          "SG": "l.poj.",
          "PL": "l.mn.",
          "BASE": "PODST",
          "COMP": "STOP.WYŻ",
          "SUP": "STOP.NAJW",
          "REFL": "ZWROT",
          "OBJ": "DOPEŁN",
          "POSS": "DZIERŻ",
          "FULL": "PEŁNA",
          "Master Your English!": "Podnieś swój angielski na wyższy poziom",
          "Start Testing": "Rozpocznij test",
          "Choose your challenge:": "Wybierz rodzaj zadania:",
          "Yes/No Questions": "Pytania Tak/Nie",
          "Text/Voice Response": "Odpowiedź tekstem/głosem",
          "Drag & Drop": "Przeciągnij i upuść",
          "Attempts": "Próby",
          "attempts": "próby",
          "Click any question to jump directly to it!": "Kliknij dowolne pytanie, aby przejść bezpośrednio do niego",
          "View Results": "Wyświetl wyniki",
          "Question": "Pytanie",
          "Hint": "Podpowiedź",
          "of": "z",
          "Select your answer – it will be checked automatically": "Wybierz odpowiedź — zostanie sprawdzona automatycznie",
          "YES": "TAK",
          "NO": "NIE",
          "Correct": "Poprawnie",
          "Partially Correct": "Częściowo poprawne",
          "Incorrect": "Niepoprawnie",
          "Next Question": "Następne pytanie",
          "Answer by Text or Voice": "Odpowiadaj tekstem lub głosem",
          "Type your answer below or click the microphone to record your voice": "Wpisz odpowiedź poniżej lub kliknij mikrofon, aby nagrać swój głos",
          "Type your answer here…": "Wpisz odpowiedź tutaj…",
          "Ready": "Gotowe",
          "Answered": "Odpowiedziano",
          "Check Answer": "Sprawdź odpowiedź",
          "Recording...": "Nagrywanie…",
          "Your answer:": "Twoja odpowiedź:",
          "Drag the words to complete the sentence:": "Przeciągnij słowa, aby uzupełnić zdanie:",
          "Your answer will be checked automatically when all gaps are filled": "Twoja odpowiedź zostanie sprawdzona automatycznie, gdy uzupełnisz wszystkie luki",
          "Next Question": "Następne pytanie",
          "Finish Test": "Zakończ test",
          "Please select at least one test type!": "Proszę wybrać co najmniej jeden typ testu!",
          "No questions available!": "Brak dostępnych pytań!",
          "Loading questions...": "Ładowanie pytań...",
          "This may take 5-10 seconds for new content": "To może potrwać 5-10 sekund dla nowej zawartości",
          "of": "z",
          "Try Again": "Spróbuj ponownie",
          "Scroll down to see your detailed error analysis": "Przewiń w dół, aby zobaczyć szczegółową analizę błędów",
          "Outstanding!": "Znakomicie!",
          "Keep Growing!": "Rozwijaj się dalej!",
          "Great Job!": "Świetna robota!",
          "Good Effort!": "Dobra robota!",
          "Error Analysis": "Analiza błędów",
          "Understanding your mistakes helps you learn better": "Zrozumienie błędów pomaga uczyć się lepiej",
          "Key Areas for Improvement": "Kluczowe obszary do poprawy",
          "Incorrect Answers": "Błędne odpowiedzi",
          "Partially Correct Answers": "Częściowo poprawne odpowiedzi",
          "Correct answer:": "Prawidłowa odpowiedź:",
          "You've mastered this material! Your understanding is exceptional.": "Ten materiał masz opanowany! Twoje zrozumienie jest wyjątkowe.",
          "Every expert was once a beginner. Keep practicing and you'll get there!": "Każdy ekspert kiedyś był początkujący. Ćwicz dalej, a osiągniesz cel!",
          "You've completed your": "Wykorzystano",
          "You're doing really well! Keep up the excellent work.": "Świetnie ci idzie! Kontynuuj tę wspaniałą pracę.",
          "You're making progress! A little more practice will help you improve.": "Robisz postępy! Trochę więcej praktyki pomoże ci się poprawić.",
          "Focus on careful reading - multiple Yes/No questions were missed. Pay attention to keywords like 'not', 'only', or 'all'.": "Skup się na uważnym czytaniu — pominięto kilka pytań Tak/Nie. Zwracaj uwagę na słowa kluczowe, takie jak 'nie', 'tylko' lub 'wszystkie'.",
          "Practice word order and grammar structures - drag & drop questions show gaps in understanding sentence construction.": "Ćwicz kolejność słów i struktury gramatyczne — zadania przeciągnij i upuść pokazują luki w zrozumieniu budowy zdań.",
          "Work on expressing complete thoughts - text/voice answers need more detail and accuracy.": "Pracuj nad wyrażaniem pełnych myśli — odpowiedzi tekstowe/głosowe wymagają więcej szczegółów i dokładności.",
          "Consider reviewing the material more thoroughly before attempting again. Take notes on key concepts.": "Rozważ dokładniejsze przejrzenie materiału przed ponowną próbą. Rób notatki z kluczowych pojęć.",
          "You're showing good understanding but need to refine some details. Focus on the specific areas mentioned above.": "Wykazujesz dobre zrozumienie, ale musisz dopracować niektóre szczegóły. Skup się na konkretnych obszarach wymienionych powyżej.",
          "No answer": "Brak odpowiedzi",
          "No answer provided": "Nie podano odpowiedzi",
          "N/A": "N/D",
          "See explanation": "Zobacz wyjaśnienie",
          "Review Your Answer": "Przejrzyj swoją odpowiedź",
          "See your answer and the explanation for this question": "Zobacz swoją odpowiedź i wyjaśnienie do tego pytania",
          "← Back to Results": "← Powrót do wyników",
          "Review Mode": "Tryb przeglądu",
          "Review all your answers and explanations": "Przejrzyj wszystkie swoje odpowiedzi i wyjaśnienia",
          "Previous": "Poprzedni",
          "Next": "Następny",
          "Please provide an answer!": "Proszę podać odpowiedź!",
          "Microphone access denied. Please type your answer.": "Odmówiono dostępu do mikrofonu. Proszę wpisać odpowiedź.",
          "Mic denied": "Mikrofon odmówiony",
          "Voice recording saved": "Nagranie głosowe zapisane",
          "Failed to submit your recording. Please try again.": "Nie udało się przesłać nagrania. Spróbuj ponownie.",
          "Failed to play recording": "Nie udało się odtworzyć nagrania",
          "Voice recording transcribed": "Nagranie głosowe przepisane",
          "Voice recording submitted": "Nagranie głosowe przesłane",
          "Processing...": "Przetwarzanie...",
          "Welcome to Dialogue Studio!": "Witaj w Dialogue Studio!",
          "firstPopDes": "Poćwiczmy dialog razem. Musisz użyć 5 słów ze słownika w naszej rozmowie.",
          "Yes, I'm Ready!": "TAK, JESTEM GOTOWY!",
          "FINISH SESSION": "ZAKOŃCZ LEKCJĘ",
          "Word Treasury": "Słowa",
          "YOUR PROGRESS": "TWÓJ POSTĘP",
          "Words Used": "Użyte słowa",
          "PRESS TO SPEAK": "NACIŚNIJ, ABY MÓWIĆ",
          "Listening to you...": "Słucham cię...",
          "I don't understand the question": "Nie rozumiem pytania",
          "I can't answer": "Nie mogę odpowiedzieć",
          "Time Invested": "Zainwestowany czas",
          "Time Spent": "Czas spędzony",
          "Welcome to your": "Witaj w swojej",
          "restFirstMessageT": "praktyce dialogowej! Cieszę się, że mogę omówić z tobą ten temat. Spróbuj użyć 5 słów pokazanych po prawej stronie.",
          "Exchanges": "Wymiany",
          "Words Mastered": "Opanowane słowa",
          "Brilliant Session!": "Genialna lekcja",
          "You've created something beautiful with words today": "Stworzyłeś dziś coś pięknego słowami",
          "Your Achievements": "Twoje osiągnięcia",
          "Perfect! You used all 5 vocabulary words brilliantly!": "Świetnie! Użyłeś wszystkich 5 słówek znakomicie!",
          "New Adventure": "Nowa przygoda",
          "Exit": "Wyjście",
          "Welcome Back!": "Witamy ponownie!",
          "You have an unfinished dialogue session for": "Masz niedokończoną sesję dialogową na temat",
          "You've used": "Użyłeś",
          "out of 5 vocabulary words.": "z 5 słów ze słownictwa",
          "Continue Session": "Kontynuuj dialog",
          "Start Over": "Zacznij od nowa",
          "In which language would you like to view the website?": "W jakim języku chcesz przeglądać stronę?",
          "Take the test — get a program personalized to your goal and level": "Zrób test — otrzymasz program dopasowany do twojego celu i poziomu",
          "It will take less than 1 minute": "Zajmie to mniej niż 1 minutę",
          "Quick & Easy": "Szybko i łatwo",
          "Step 1 of 2": "Krok 1 z 2",
          "Step 2 of 2": "Krok 2 z 2",
          "What is your current English level?": "Jaki jest Twój obecny poziom angielskiego?",
          "What's your main goal with English?": "Jaki jest Twój główny cel z angielskim?",
          "Great! We've prepared your personalized learning path": "Świetnie! Przygotowaliśmy Twoją spersonalizowaną ścieżkę nauki",
          "Finish test": "Zakończ test",
          "English Learning Journey": "Podróż nauki angielskiego",
          "Lower Level": "Niższy poziom",
          "Add Plan": "Dodaj plan",
          "Raise Level": "Podnieś poziom",
          "Learning Progress": "Postęp nauki",
          "Current Level": "Obecny poziom",
          "Basics": "Podstawy",
          "Conversations": "Rozmowy",
          "Introduction": "Wprowadzenie",
          "Greetings": "Powitania",
          "Practice": "Praktyka",
          "Daily Talk": "Codzienne rozmowy",
          "Questions": "Pytania",
          "Social": "Społeczne",
          "Business": "Biznes",
          "Emails": "E-maile",
          "Meetings": "Spotkania",
          "Airport": "Lotnisko",
          "Hotels": "Hotele",
          "Dining": "Jedzenie",
          "Grammar": "Gramatyka",
          "Idioms": "Idiomy",
          "Fluency": "Płynność",
          "I want to choose the video myself": "Chcę sam wybrać wideo",
          "Continue Learning": "Kontynuuj naukę",
          "TRY 2-MIN DEMO": "Wypróbuj 2-minutowe demo",
          "WHY CHOOSE AI LINGUA?": "Dlaczego wybrać AI Lingua?",
          "REAL-LIFE VIDEOS": "Filmy z życia codziennego",
          "AI-POWERED PRACTICE": "Ćwiczenia z AI",
          "ALL LEVELS WELCOME": "Dla wszystkich poziomów",
          // Level descriptions
          "Preparatory course. Ideal for beginners": "Kurs przygotowawczy. Idealny dla początkujących",
          "I am starting to learn English.": "Zaczynam uczyć się angielskiego.",
          "I already know some words": "Już znam niektóre słowa",
          "I can already speak a little": "Już mogę trochę mówić",
          "I confidently speak on various topics": "Pewnie rozmawiam na różne tematy",
          "I can discuss various topics in detail": "Mogę szczegółowo omawiać różne tematy",
          "Enter your credentials to access your account": "Wprowadź swoje dane logowania, aby uzyskać dostęp do konta",
          "coming soon": "bardzo szybko",
          "Login successful": "Logowanie udane",
          "Login failed": "Błąd logowania",
          "Create your account to get started": "Utwórz konto, aby rozpocząć",
          "Plans that fit your needs": "Wybierz plan dopasowany do swoich potrzeb",
          "Simple, scalable pricing that grows with you.": "Prosty i elastyczny cennik, który skaluje się razem z Tobą.",
          "Free": "Bezpłatny",
          "Free for everyone": "Darmowy dla wszystkich",
          "Watch learning videos": "Oglądanie filmów szkoleniowych",
          "Add words to personal vocabulary": "Dodawanie słów do własnego słownika",
          "Study & review words": "Nauka i powtórki słówek",
          "Video comprehension checks": "Testy rozumienia wideo",
          "AI voice dialogues": "Dialogi głosowe z AI",
          "Certificate upon completion": "Certyfikat po ukończeniu",
          "Priority support": "Priorytetowe wsparcie",
          "Sign Up": "Zarejestruj się",
          "/month": "/miesiąc",
          "Plans that fit your needs": "Plany dopasowane do Twoich potrzeb",
          "Simple, scalable pricing that grows with you.": "Proste, skalowalne cenowanie, które rośnie wraz z Tobą",
          "Free": "Za darmo",
          "Free for everyone": "Bezpłatnie dla każdego",
          "Watch learning videos": "Oglądanie filmów szkoleniowych",
          "Add words to personal vocabulary": "Dodawanie słów do własnego słownika",
          "Study & review words": "Nauka i powtórki słówek",
          "Video comprehension checks": "Testy rozumienia wideo",
          "AI voice dialogues": "Dialogi głosowe z AI",
          "Certificate upon completion": "Certyfikat po ukończeniu",
          "Priority support": "Priorytetowe wsparcie",
          "For individuals & freelancers": "Dla osób indywidualnych i freelancerów",
          "7 days free trial": "7-dniowy bezpłatny okres próbny",
          "AI voice dialogues — 10 per day": "Dialogi głosowe z AI — 10 dziennie",
          "Unlimited AI voice dialogues": "Nielimitowane dialogi głosowe z AI",
          "For teams & agencies": "Dla zespołów i agencji",
          "For schools, businesses, universities": "Dla szkół, firm i uniwersytetów",
          "All Pro features included": "Wszystkie funkcje planu 'Profesjonalny'",
          "Per-user progress reports": "Raporty postępów dla każdego użytkownika",
          "Training reminders for learners": "Przypomnienia o nauce dla uczących się",
          "Custom branding options": "Opcje dostosowania brandingu",
          "Dedicated account manager": "Dedykowany opiekun konta",
          "Volume discounts available": "Dostępne rabaty ilościowe",
          "API access & integrations": "Dostęp do API i integracje",
          "Contact Us": "Skontaktuj się z nami",
          "Get Started": "Zacznij",
          "Custom Pricing": "Cena indywidualna",
          "Pro": "Profesjonalny",
          "Popular": "Popularny",
          "Cancel & Refund Policy": "Polityka rezygnacji i zwrotów",
          "Pricing": "Cennik",
          "All rights reserved": "Wszystkie prawa zastrzeżone",
          "Terms of Use": "Warunki użytkowania",
          "Privacy Policy": "Polityka prywatności",
          "Cookie Settings": "Ustawienia plików cookie",
          "Last updated": "Ostatnia aktualizacja",
          "Terms of Use2": "Regulamin korzystania",
          "temrs1Text": "AI Lingua to platforma online do nauki języka angielskiego (lekcje wideo, słownik, testy ze zrozumienia, ćwiczenia dialogów wspierane przez AI). Dostęp zapewniany jest wyłącznie w formie cyfrowej; towary fizyczne nie są dostarczane.",
          "terms2": "Płatności są przetwarzane przez Paddle.com; faktury/paragony oraz należne podatki administruje Paddle.",
          "terms3": "Właściciel usługi: Indywidualny Przedsiębiorca Alona Oleksandriwna Korchynska (FOP Korchynska Alona Oleksandrivna)",
          "terms4": "| Właściwość prawa: Ukraina",
          "Tel": "Tel",
          "terms5": "Adres korespondencyjny: Starokostiantyniw, obwód chmielnicki, 31100, Ukraina",
          "terms6": "Minimalny wiek użytkownika to 13 lat; osoby poniżej 13 lat nie mogą korzystać z Usługi. Jeśli mieszkasz w kraju UE/EOG lub w Zjednoczonym Królestwie i masz mniej niż 16 lat, wymagana jest potwierdzona zgoda rodzica/opiekuna (jeśli prawo Twojego kraju przewiduje niższy wiek zgody, będziemy to respektować). Użytkownik jest zobowiązany do zachowania poufności danych logowania i nieudostępniania dostępu osobom trzecim.",
          "terms7": "Paddle.com jako Merchant of Record.",
          "terms8": "Płatności są przyjmowane, a faktury/paragony wystawiane przez Paddle.com jako sprzedawcę/Merchant of Record, w tym obliczanie i pobór obowiązujących podatków/VAT. Plany i ceny są publikowane na stronie cennika i mogą ulec zmianie z uprzednim powiadomieniem, jeśli wpływają na przyszłe okresy rozliczeniowe. Subskrypcje odnawiają się automatycznie, chyba że zostaną anulowane w panelu użytkownika (po anulowaniu automatyczne odnowienie jest wyłączane; dostęp trwa do końca już opłaconego okresu).",
          "terms9": "Okres próbny wynosi 7 dni. Jeśli subskrypcję zakupiono w trakcie okresu próbnego, płatny dostęp zaczyna się natychmiast, a okres próbny trwa do końca 7 dni (łączny dostęp nie jest 'podwajany'). Dostępna jest wersja bezpłatna o ograniczonej funkcjonalności.",
          "terms10": "Zwroty po opłaceniu subskrypcji nie są udzielane, w tym częściowe/proporcjonalne, z wyjątkiem przypadków wymaganych przez bezwzględnie obowiązujące przepisy lub przewidzianych w naszej polityce wyjątków.",
          "terms11": "Zabronione są: naruszenia prawa; treści agresywne, dyskryminujące lub szkodliwe; próby nieuprawnionego dostępu, ingerencja w działanie Usługi lub inżynieria wsteczna; zautomatyzowane masowe pozyskiwanie danych; oszustwa płatnicze; współdzielenie jednego konta przez wiele osób; przesyłanie lub wprowadzanie materiałów naruszających prawa własności intelektualnej osób trzecich. Konta naruszające niniejszy Regulamin mogą zostać ograniczone lub zamknięte po uprzednim powiadomieniu, gdy jest to możliwe.",
          "terms12": "Materiały Usługi (w tym filmy, testy, kod oprogramowania, projekt, teksty) są chronione prawami własności intelektualnej. Użytkownikowi udzielana jest ograniczona, niewyłączna, nieprzenoszalna licencja na osobiste, niekomercyjne korzystanie z Usługi. Treści przesłane przez użytkownika pozostają jego własnością; użytkownik udziela Usłudze ograniczonej licencji na wykorzystanie takich treści w celu świadczenia i ulepszania Usługi.",
          "terms13": "Korzystamy z dostawców zewnętrznych (hosting, analityka oraz modele LLM dla dialogów AI). Dane są przetwarzane wyłącznie w celu świadczenia, utrzymania i ulepszania Usługi. Nie wykorzystujemy Twoich treści do trenowania ogólnych modeli dostawców, chyba że wyraźnie wskażemy inaczej i uzyskamy Twoją zgodę. Wykaz kluczowych dostawców i lokalizacji serwerów znajduje się w Polityce prywatności.",
          "terms14": "Możemy aktualizować funkcje, ceny i warunki. O istotnych zmianach wpływających na płatności lub dostęp informujemy z co najmniej 7-dniowym wyprzedzeniem (e‑mail/baner w koncie). Dalsze korzystanie po dacie wejścia zmian w życie oznacza akceptację zaktualizowanych warunków.",
          "terms15": "Możemy zawiesić lub zakończyć dostęp użytkownika w przypadku naruszenia niniejszego Regulaminu albo z przyczyn bezpieczeństwa/prawnych, z rozsądnym powiadomieniem, gdy to możliwe. Po zakończeniu dostępu możesz wyeksportować swoje dane w ciągu 30 dni (z wyjątkiem ograniczeń prawnych).",
          "terms16": "Usługa jest dostarczana 'w stanie takim, w jakim jest' i 'w miarę dostępności'. W zakresie dozwolonym przez prawo nie udziela się dorozumianych gwarancji przydatności czy dostosowania do określonego celu. Łączna odpowiedzialność właściciela Usługi wobec użytkownika jest ograniczona do kwoty opłat uiszczonych przez danego użytkownika w ciągu ostatnich 12 miesięcy.",
          "terms17": "Niniejszy Regulamin podlega prawu Ukrainy; spory podlegają właściwym sądom Ukrainy, chyba że bezwzględnie obowiązujące przepisy stanowią inaczej.",
          "terms18": "Pytania dotyczące Usługi i rozliczeń (w tym rezygnacji z subskrypcji):",
          "About Us": "O nas",
          "Accounts and Age": "Konta i wiek",
          "Subscriptions, Pricing, and Billing": "Subskrypcje, ceny i rozliczenia",
          "Trial Period and Free Version": "Okres próbny i wersja bezpłatna",
          "Refunds": "Zwroty",
          "Acceptable Use": "Dozwolone korzystanie",
          "Intellectual Property Rights": "Prawa własności intelektualnej",
          "Third-Party Technologies and AI": "Technologie stron trzecich i AI",
          "Service Availability and Changes": "Dostępność Usługi oraz zmiany Usługi i cen",
          "Termination of Access": "Zakończenie dostępu",
          "Warranty Disclaimer": "Wyłączenie gwarancji i ograniczenie odpowiedzialności",
          "Governing Law and Contact": "Prawo właściwe, jurysdykcja i kontakt",
          "October": "października",
          "Who We Are": "Kim jesteśmy",
          "privacy1": "Indywidualny Przedsiębiorca Alona Oleksandriwna Korchynska jest administratorem danych dla AI Lingua. Kontakt:",
          "Data We Process": "Jakie dane przetwarzamy",
          "privacy2": "e‑mail, hasło (zahashowane), imię/pseudonim.",
          "privacy3": "postępy, wyniki testów, ustawienia, dzienniki aktywności.",
          "privacy4": "przetwarzane przez Paddle.com (otrzymujemy status transakcji/subskrypcji i numer zamówienia; nie przechowujemy pełnych danych kart).",
          "privacy5": "pliki cookie/telemetria na potrzeby działania serwisu, bezpieczeństwa i analityki.",
          "Purposes": "Cele",
          "privacy6": "Świadczenie Usługi, rozliczenia, wsparcie, bezpieczeństwo, analityka/ulepszenia, wypełnianie obowiązków prawnych.",
          "Legal Bases": "Podstawy prawne",
          "privacy7": "Wykonanie umowy; uzasadniony interes; zgoda (gdzie wymagana); obowiązek prawny.",
          "Data Sharing": "Udostępnianie danych",
          "privacy8": "Dostawcom infrastruktury/analityki oraz Paddle.com — przy zachowaniu odpowiednich zabezpieczeń.",
          "privacy8.1": "Dostawcom infrastruktury/analityki oraz",
          "privacy8.2": "— przy zachowaniu odpowiednich zabezpieczeń.",
          "Retention": "Okres przechowywania",
          "privacy9": "Tak długo, jak konto jest aktywne; niektóre zapisy mogą być przechowywane dłużej, jeśli wymagają tego przepisy (np. sprawozdawczość finansowa).",
          "Data Subject Rights": "Prawa osoby, której dane dotyczą",
          "privacy10": "Żądania dostępu/usunięcia/przenoszenia/sprzeciwu prosimy kierować na adres: ailinguaservice@gmail.com. Odpowiadamy w ciągu 30 dni. Masz również prawo wnieść skargę do Rzecznika Praw Człowieka przy Parlamencie Ukrainy (ombudsman) lub do organu nadzorczego w kraju Twojego zamieszkania.",
          "International Transfers": "Transfery międzynarodowe",
          "privacy11": "W przypadku przekazywania danych poza Ukrainę/UE stosujemy Standardowe Klauzule Umowne (SCC) lub inne odpowiednie zabezpieczenia. Wykaz głównych dostawców i krajów przetwarzania podajemy w odpowiedniej sekcji/załączniku.",
          "Cookies": "Cookies",
          "privacy12": "Używamy niezbędnych plików cookie do działania serwisu oraz plików cookie analitycznych/marketingowych wyłącznie za Twoją zgodą. W wyborze możesz w każdej chwili wprowadzić zmiany w banerze zgody.",
          "Account": "Konto",
          "Learning": "Nauka",
          "Payments": "Płatności",
          "Technical": "Techniczne",
          "Cancellation and Refund Policy": "Polityka rezygnacji i zwrotów",
          "refund1": "7 dni. Jeśli subskrypcję zakupiono w trakcie okresu próbnego, dostęp próbny trwa do końca 7 dni.",
          "refund2": "obciążenie przez Paddle; subskrypcja odnawia się automatycznie do czasu rezygnacji.",
          "refund3": "w dowolnym momencie w Twoim panelu/przez Paddle; po rezygnacji dostęp trwa do końca już opłaconego okresu.",
          "refund4": "nie są udzielane po opłaceniu subskrypcji (w tym częściowe/proporcjonalne), z wyjątkiem przypadków wymaganych przez obowiązujące prawo.",
          "refund5": "Kontakt w sprawach rozliczeń/rezygnacji:",
          "Trial period:": "Okres próbny:",
          "Payment and auto-renewal:": "Płatność i automatyczne odnawianie:",
          "CNCL": "Rezygnacja:",
          "RFND": "Zwroty:",
          "app-header-text": "Teraz przećwiczymy dialog z filmu. Mówimy tak samo jak w nagraniu: te same słowa i ten sam temat. Zaczynamy.",
          "Try saying it like this:": "Spróbuj powiedzieć tak",
          "Keep practicing!": "Ćwicz dalej!",
          "Not bad!": "Nieźle!",
          "Good job!": "Dobra robota!",
          "Excellent result!": "Doskonały wynik!",
          "Skip": "Pomiń",
          "Зробіть перерву та перегляньте!": "Zrób sobie przerwę i przejrzyj!",
          "You\'ve tried five times already - that\'s great persistence! But it seems like it would be worth refreshing the material so the dialogue goes easier.": "Próbowałeś już pięć razy – to wielka wytrwałość! Ale wydaje się, że warto odświeżyć materiał, żeby dialogi były łatwiejsze.",
          "Mistakes are part of learning": "Błędy są częścią nauki",
          "Nothing scary, it happens!": "Nic strasznego, zdarza się!",
          "It seems difficult to answer by voice for now. Let\'s first review the material again - after that it will be much easier!": "Na razie trudno odpowiedzieć na głos. Najpierw przejrzyjmy materiał jeszcze raz – potem będzie o wiele łatwiej!",
          "One step back is two steps forward": "Jeden krok w tył to dwa kroki w przód",
          "We recommend returning to:": "Zalecamy powrót do:",
          "Learn Words2": "Nauka słów",
          "Review key words and phrases from the lesson": "Przejrzyj kluczowe słowa i zwroty z lekcji",
          "Watch Video2": "Obejrzyj wideo",
          "Watch the dialogue again with subtitles": "Obejrzyj dialog jeszcze raz z napisami",
          "I want to continue the dialogue": "Chcę kontynuować dialog.",
          "Lesson completed": "Lekcja ukończona",
          "Great! Lesson": "Świetnie! Lekcja",
          "completed!": "zakończony!",
          "You\'ve completed the dialogue practice for this video. You can now move on to the next lesson or review this one again.": "Ukończyłeś praktykę dialogową dla tego filmu. Możesz teraz przejść do następnej lekcji lub ponownie przejrzeć tę.",
          "Repeat Lesson": "Powtórz Lekcję",
          "Next Lesson": "Następna Lekcja",
          "Almost there!": "Już prawie!",
          "Don't be sad": "Nie bądź smutny",
          "Every attempt": "Każda próba",
          "is a step forward": "to krok naprzód",
          "This time the lesson": "Tym razem lekcja",
          "was not completed — but that's okay. Mistakes are part of learning. Repeat the lesson or move on: your choice!": "nie został ukończony — ale to nic. Błędy są częścią nauki. Powtórz lekcję albo idź dalej: twój wybór!",
          "Awesome plan for you": "Świetny plan dla Ciebie",
          "Access to 30 video pack": "Dostęp do pakietu 30 filmów",
          "Subscriptions": "Subskrypcje",
          "Sign in to manage your subscription": "Zaloguj się, aby zarządzać swoją subskrypcją",
          "Please log in to view and manage your subscription details, billing information, and account settings.": " Proszę zaloguj się, aby zobaczyć i zarządzać szczegółami swojej subskrypcji, informacjami rozliczeniowymi i ustawieniami konta.",
          "You can manage your billing information and subscription here": "Tutaj możesz zarządzać informacjami o rozliczeniach i subskrypcją",
          "You're on the": "Jesteś na",
          "plan": "planie",
          "Your subscription is active until": "Twoja subskrypcja jest aktywna do",
          "Next renewal:": "Następne odnowienie:",
          "Plan cost": "Koszt planu",
          "Status": "Status",
          "Auto-renewal": "Automatyczne odnawianie",
          "Cancel Subscription": "Anuluj subskrypcję",
          "Upgrade your plan": "Ulepsz swój plan",
          "Processing payment": "Obróbka płatności",
          "We are waiting for confirmation from the payment provider...": "Oczekujemy potwierdzenia od dostawcy płatności...",
          "Your subscription plan": "Twój plan subskrypcji",
          "Activation progress": "Postęp aktywacji",
          "Do not close this page - we will notify you immediately": "Nie zamykaj tej strony - powiadomimy Cię natychmiast",
          "Successfully activated!": "Pomyślnie aktywowano!",
          "Your subscription plan": "Twój plan subskrypcji",
          "Do not waste time - let's learn together! All features of the plan": "Nie martw się o czas - pozwólmy nauczyć się razem! Wszystkie funkcje planu",
          "are already available in your account.": "są już dostępne w Twoim koncie.",
          "Thank you for trusting AI Lingua!": "Dziękujemy za zaufanie do AI Lingua!",
          "Subscription": "Subskrypcja",
          "Стандарт": "Standard",
          "Преміум": "Premium",
          "After registration, you'll get your personalized course and be able to track your progress.": "Po rejestracji otrzymasz spersonalizowany kurs i będziesz mógł śledzić swoje postępy.",
          "Start your language learning journey with AI-powered lessons tailored just for you!": "Rozpocznij naukę języka angielskiego dzięki lekcjom opartym na sztucznej inteligencji, dostosowanym do Twoich potrzeb!",
          "Welcome Back, aliona!": "Witamy ponownie, aliona!",
          "Let's continue studying together": "Kontynuujmy naukę razem",
          "Learned Words": "Nauczonych słów",
          "Completed Videos": "Ukończonych filmów",
          "Correct Answers": "Poprawnych odpowiedzi",
          "Successful Dialogues": "Ukończonych dialogów",
          "My Courses": "Moje kursy",
          "View all courses": "Zobacz wszystkie kursy",
          "Business English": "Angielski biznesowy",
          "Intermediate": "Pośredni",
          "24 lessons": "24 lekcje",
          "Progress": "Postęp",
          "lessons done": "lekcji ukończonych",
          "lessons left": "lekcji pozostałych",
          "Conversational English": "Angielski konwersacyjny",
          "30 lessons": "30 lekcji",
          "Travel English": "Angielski podróżny",
          "15 lessons": "15 lekcji",
          "My Videos": "Moje filmy",
          "View all": "Zobacz wszystkie",
          "Name": "Imię",
          "Email": "E-mail",
          "Phone": "Telefon",
          "Message": "Wiadomość",
          "Submit": "Wyślij",
          "Please fill in all the fields!": "Proszę wypełnić wszystkie pola!",
          "Completed Dialogs": "Ukończone dialogi",
          "Введіть коректну адресу електронної пошти.": "Wprowadź poprawny adres e-mail.",
          "The email address and/or password you specified are not correct.": "Podany adres e-mail i/lub hasło są niepoprawne.",
          "Choose a username": "Wybierz nazwę użytkownika",
          "Це поле обов'язкове.": "To pole jest wymagane.",
          "A user is already registered with this email address.": "Użytkownik jest już zarejestrowany z tym adresem e-mail.",
          "Register to save your progress": "Zarejestruj się, aby zapisać swoje postępy",
          "Register": "Zarejestruj się",
          "Previous Lesson": "Poprzednia lekcja",
          "Lesson Completed": "Lekcja ukończona",
          "Lesson Not Completed": "Lekcja nie ukończona",
          "Email must contain @": "E-mail musi zawierać @",
          "Email must contain . (dot)": "E-mail musi zawierać . (kropkę)",
          "Invalid email format (example@domain.com)": "Nieprawidłowy format e-mail (example@domain.com)",
          "At least 8 characters": "Co najmniej 8 znaków",
          "Must contain letters": "Musi zawierać litery",
          "Must contain numbers": "Musi zawierać cyfry",
        },
      },
    },
    supportedLngs: ["en", "uk", "pl"],
    fallbackLng: "uk",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
